/**
 * Typed node data interfaces -- AUTO-GENERATED from schemas/nodes/*.json.
 *
 * Do not edit manually. Run: python scripts/gen_node_metas.py
 */

import * as Y from 'yjs'
import type { Node } from 'reactflow'

export type JsonPrimitive = string | number | boolean | null
export type YDocPrimitive = JsonPrimitive
export type YDocValue = YDocPrimitive | YDocValue[] | { [key: string]: YDocValue } | Y.Map<YDocValue> | Y.Array<YDocValue> | undefined
export type YDocWriteValue = YDocValue | File | object
export type YDocWriteRecord = Record<string, YDocWriteValue>

// ---------------------------------------------------------------------------
// Shared types (auto-generated from schemas/shared_types.json)
// ---------------------------------------------------------------------------

export type BasicAssetMetadata = { creation_time?: string; source?: string; model?: string; provider?: string; mode?: string; duration_seconds?: number; regenerated?: boolean; regeneration_time?: string; aspect_ratio?: string }

export type GeneratedAssetMetadata = { model?: string; provider?: string; mode?: string; loop?: string; segments?: number; segment_start_times?: number[]; character_name?: string; voice_id?: string; voice_type?: string; duration_seconds?: number; regenerated?: boolean; regeneration_time?: string; aspect_ratio?: string }

export type BasicAsset = { id: string; local_path?: string; metadata?: BasicAssetMetadata }

export type AssetRef = { type: string; data: BasicAsset }

export type GeneratedAssetEntry = { user_prompt?: string; result?: BasicAsset; refs?: AssetRef[]; metadata?: GeneratedAssetMetadata }

export type GeneratedImageWithHistoryData = { history: GeneratedAssetEntry[]; picked_index: number }

export type GeneratedVideoWithHistoryData = { history: GeneratedAssetEntry[]; picked_index: number }

export type GeneratedAudioWithHistoryData = { history: GeneratedAssetEntry[]; picked_index: number }

// ---------------------------------------------------------------------------
// Named port types (auto-generated from schema pythonType → tsType)
// ---------------------------------------------------------------------------

export type AdCaptionsDict = { lines: string[] }

export type AudioRemixConfigDict = { groups: Array<{ id: string; character: string; voice_role_id?: string; emotion?: string; text?: string; status?: string; type?: 'dialogue' | 'voiceover'; tracks: Array<{ id: string; label: string; startS: number; endS: number; highlighted: boolean; sourceSegmentIdx?: number; sourceVersionLabel?: string; fadeInS?: number; fadeOutS?: number; sourceDurationS?: number; sourceType?: 'tts' | 'clip' }> }>; sourceOriginalIndex?: number; sourceOriginalPath?: string; duckDepthDb?: number | null }

export type CaptionWordDict = { word: string; start_s: number; end_s: number }

export type CharacterAsset = { user_prompt?: string; images?: { main?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } }; character_sheet?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } }

export type CompositionDict = { shot_type?: string; angle?: string; focus?: string }

export type DirectorCrewDict = { director?: string; character?: string; location?: string; object?: string; storyboard?: string; scriptwriter?: string; image?: string; video?: string; sound?: string }

export type DirectorPendingToolStateDict = { conversation_id?: string; last_tool_name?: string; last_tool_status?: string; pending_tool_id?: string; pending_tool_name?: string }

export type GeneratedImageWithHistory = GeneratedImageWithHistoryData

export type GeneratedVideoWithHistory = GeneratedVideoWithHistoryData

export type LocationAsset = { user_prompt?: string; images?: { main?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } } }

export type LocationMetadataDict = { name?: string; style?: string | null; time_of_day?: string; weather?: string }

export type ObjectAsset = { user_prompt?: string; images?: { main?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } } }

export type ObjectMetadataDict = { name?: string; style?: string | null; description?: string }

export type ResolvedVoiceMapDict = Record<string, string>

export type ScreenplayResultDict = { error?: string; voice_roles?: VoiceRoleDict[]; scenes?: Array<{ scene_number: number; location: string; interior_exterior?: string; time_of_day?: string; characters?: string[]; entries: Array<{ type: string; character?: string; emotion?: string; voice_role_id?: string; text: string }>; estimated_duration_s?: number; beat_type?: string; energy?: string; transition_out?: { beat: string; duration_s?: number } }>; music_theme?: string; sequence_index?: number; sequence_title?: string }

export type SoundGeneratedAudioDict = { history?: Array<{ user_prompt?: string; result?: { local_path?: string; metadata?: { creation_time?: string; source?: string; model?: string } }; metadata?: { model?: string; provider?: string; mode?: string; loop?: string; segments?: number; segment_start_times?: number[]; character_name?: string; voice_id?: string; voice_type?: string; duration_seconds?: number } }>; picked_index?: number }

export type SpeechSegmentDict = Array<{ character: string; emotion: string; timeRange: string; audioUrl: string | null; versions: number; selectedVersion: number }>

export type Stage3dSceneDocDict = { version: number; settings?: { skyColor?: string; gridSnap?: boolean; showLabels?: boolean }; objects: Array<{ id: string; kind: string; name?: string; transform?: { position?: number[]; rotation?: number[]; scale?: number[] }; bodyType?: string; color?: string; pose?: { preset?: string; joints?: Record<string, number[]> }; shape?: string; fov?: number; lookAt?: number[] | { targetId: string }; aspect?: string }>; activeCameraId?: string | null }

export type StoryContextDict = { synopsis?: string; characters?: string[]; setting?: string }

export type StoryDirectionFieldDict = { value: string; status: string }

export type StoryboardDecomposeMetaDict = { role?: string; storyboard_group_id?: string; scene_id?: string; group_node_id?: string; grid_index?: number; grid_count?: number; grid_layout?: number[]; grid_beats?: string[]; panel_offset?: number; ref_node_ids?: string[]; style?: string; clip_mode?: string; clip_index?: number }

export type StoryboardMetadataDict = { aspect_ratio?: string; scene_id?: string; regenerated?: boolean; regeneration_time?: string; model?: string; source_signature?: string }

export type TimelineConfigDict = { operation: 'timeline_render'; timeline: { clips: Array<{ id?: string; source_path: string; start_time?: number; end_time?: number; order?: number; speed?: number; start_offset?: number; track_index?: number; volume?: number; muted?: boolean; fade_out_s?: number; fade_in_s?: number }>; audio?: { source_path: string; start_time?: number; end_time?: number; volume?: number } | null; audio_tracks?: Array<{ source_path: string; start_time?: number; end_time?: number; volume?: number; role?: 'original' | 'replacement' | 'sfx'; start_offset?: number; speed?: number; track_index?: number }> | null; video_tracks_meta?: Array<{ track_index: number; muted?: boolean }> | null; audio_tracks_meta?: Array<{ track_index: number; muted?: boolean }> | null; total_duration?: number; video_track_count?: number; audio_track_count?: number; magnet_enabled?: boolean } }

export type UpstreamContextDict = { role?: string; name?: string; description?: string; prompt?: string; style?: string; aspect_ratio?: string; scene_id?: string; source_node_id?: string; source_node_type?: string; source_output?: string; local_path?: string }

export type VersionsMetaDict = { count?: number; picked?: number }

export type VoiceMapDict = Record<string, string>

export type VoiceProfileDict = { provider: string; voice_id: string; voice_name: string; description: string; name?: string; audio_sample?: string; speech_text?: string; characteristics?: string[]; pronunciation_guide?: string }

export type VoiceRoleDict = { id: string; label: string; kind: string; source_character?: string; voice_description?: string }

export type VoiceSettingsDict = { stability?: number; similarity_boost?: number; style?: number; speed?: number }

export type WebtoonDialogueDict = { character: string; text: string }

export type NodeStatus = 'pending_execution' | 'running' | 'completed' | 'error' | 'idle' | 'pending_cost_confirmation'

export const NODE_STATUSES: readonly NodeStatus[] = ['pending_execution', 'running', 'completed', 'error', 'idle', 'pending_cost_confirmation']

/** USD per second of video output, by backend pricing key. */
export const VIDEO_MODEL_USD_PER_SECOND: Record<string, { default: number; '4k'?: number }> = {
  'kling-o3-pro': { default: 0.069 },
  'kling-v3-pro': { default: 0.069 },
  'seedance-2.0-image-to-video': { default: 0.3 },
  'seedance-2.0-reference-to-video': { default: 0.3 },
  'seedance-2.5': { default: 0.2335 },
  'veo-2.0-generate-001': { default: 0.35 },
  'veo-3.0-fast-generate-001': { default: 0.15 },
  'veo-3.0-generate-001': { default: 0.4 },
  'veo-3.1-fast-generate-preview': { default: 0.15, '4k': 0.35 },
  'veo-3.1-generate-preview': { default: 0.4, '4k': 0.6 },
}

/** UI model name -> backend pricing key (matches Python aliases). */
export const VIDEO_MODEL_ALIAS: Record<string, string> = {
  'veo-3.1': 'veo-3.1-generate-preview',
}

/** Compute sparks cost for ONE video generation (no retry multiplier).
 *
 * Mirrors backend CostEstimator: sparks = max(1, round(perSecond * duration * 100))
 * for any USD > 0, else 0. Returns 0 for unknown models so the UI degrades
 * gracefully rather than showing a misleading hardcoded number.
 */
export function videoSparksPerGeneration(model: string, resolution: string, durationSeconds: number): number {
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return 0
  const lookupKey = VIDEO_MODEL_ALIAS[model] ?? model
  const tiers = VIDEO_MODEL_USD_PER_SECOND[lookupKey]
  if (!tiers) return 0
  const wants4k = typeof resolution === 'string' && resolution.toLowerCase() === '4k'
  const perSecond = (wants4k && tiers['4k'] !== undefined) ? tiers['4k'] : tiers.default
  if (!perSecond || perSecond <= 0) return 0
  const usd = perSecond * durationSeconds
  return usd <= 0 ? 0 : Math.max(1, Math.round(usd * 100))
}

/** Upload a local audio file */
export interface AudioNodeData {
  /**  */
  in_file_name?: string
  /** The uploaded audio */
  out_audio?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Assembles an editorial brand film: a flat paper canvas, a serif headline per beat, and one generated insert per beat in a card whose shape changes (wide, square, triptych), cut to a beat-locked voiceover over a ducked music bed, ending on a wordmark. Each insert is paced to its beat (hold, assemble, rest); the layout is a fixed measured grid, so only the words and pictures vary. Built by create_brand_film, which wires every upstream node. */
export interface BrandFilmNodeData {
  /** JSON: {"brand": wordmark text, "beats": [{"headline", "subline", "layout": wide|square|triptych|triptych-center, "seconds"}]}. Beat i uses in_clips[i] and in_voiceover[i]. */
  in_plan?: string
  /** One generated insert per beat, in beat order (video_generator.out_video). */
  in_clips?: Array<string | null>
  /** One narration line per beat, in beat order; each starts just after its beat's cut. A beat with no line is silent under the bed. */
  in_voiceover?: Array<string | null>
  /** The bed under the whole film. Loops if short; ducks under the voice. */
  in_music?: string
  /** Display name for this node on the canvas. */
  in_name?: string
  /** The finished film with its soundtrack. */
  out_video?: string
  /** Composition lint/validate/render log, for diagnosing a failed render. */
  out_render_log?: string
  /** Resolved display name. */
  out_name?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Burns captions into a finished video. 'plain' renders one static line per spoken segment using the transcriber already in this repo, so it needs no extra service. 'karaoke' highlights each word as it lands — the Chinese short-drama convention — and gets word-level timings from hypit's WhisperX service (POST /transcribe); the caption rendering itself is ours either way. Chinese short-drama platforms effectively require burned-in subtitles and nothing else in the graph produces them. Takes a rendered video (typically stitch_film's output or a video_generator clip) and returns the same cut with captions. */
export interface CaptionerNodeData {
  /** The rendered video to caption. Its own audio track is the transcription source, so dialogue must already be present — caption a clip after voice acting, not before. */
  in_video?: string
  /** Spoken language of the video. Passed to the transcriber, and to WhisperX alignment in karaoke mode. Must match what is actually spoken; a mismatch yields caption text that does not match the dialogue, which is worse than no captions. */
  in_language?: string
  /** 'karaoke' (default) highlights each word as it is spoken — the short-drama convention — and needs hypit's WhisperX service for word timings; it renders as 'plain' with a logged reason when that service is not configured. 'plain' renders a static line per cue. */
  in_caption_style?: string
  /** Display name for this node on the canvas. */
  in_name?: string
  /** Revision note for a rerun, e.g. 'captions sit too low' or 'smaller type'. */
  in_feedback?: string
  /** The input video with captions burned in. Same duration and audio as the input. */
  out_video?: string
  /** Timed caption cues, each with a start and end in seconds. Granularity depends on the mode that ran: 'karaoke' gives one entry per WORD from WhisperX alignment (for Chinese that is one per character), 'plain' gives one entry per spoken LINE, carried in the same 'word' field. Kept so the recognised text can be checked against the intended script. A rerun re-transcribes rather than reusing this. */
  out_transcript?: CaptionWordDict[]
  /** Resolved display name. */
  out_name?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Design a character with visual sheet and voice profile */
export interface CharacterDesignerNodeData {
  /** Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies. */
  in_upstream?: UpstreamContextDict
  /** Optional reference image to guide the visual design */
  in_images?: Array<string | null>
  /** Remote reference image URLs the delegated host attaches to the generation request (ponpon-web build-flow-generation-request.ts reads this field into payload imageUrls). Machine-owned seam: the delegated-revision fold writes the picked image here as the EDIT TARGET reference and clears it when the revision is consumed. Do not set manually. */
  in_ref_images?: string[]
  /** Name of the character being designed */
  in_name?: string
  /** Character role (e.g. protagonist, supporting, antagonist) */
  in_role?: string
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** Describe appearance, personality, voice... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** Per-word pronunciation overrides for this character's name and terms. One rule per line: 'word → pronunciation' (alias) or 'word → /IPA/' (phoneme). Example: L'Ora → LOH-rah. Automatically applied to all downstream speech generation using this character's voice. */
  in_pronunciation_guide?: string
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Free-text description of this character's voice (e.g. 'young adult male voice, slightly anxious, mid-range tenor, American accent'). Used by seedance_inline dialogue mode as a voice ledger so the same descriptor primes Seedance every clip the character speaks in. Has no effect when dialogue_mode == 'tts_remix' (TTS voice IDs are pinned via the existing voice profile flow). */
  in_voice_descriptor?: string
  /** Character name (mirrors in_name for downstream label edges) */
  out_name?: string
  /** Generated multi-view character reference sheet */
  out_character_sheet?: CharacterAsset
  /** Voice metadata including provider, voice_id, voice_name, and description */
  out_voice_profile?: VoiceProfileDict
  /** Current selected character image */
  out_image?: string
  /** batch_pending */
  batch_pending?: number
  /** picked_variant_index */
  picked_variant_index?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Debug node that hangs forever for testing */
export interface DebugHangNodeData {
  /** Debug label */
  in_label?: string
  /** Debug result */
  out_result?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Orchestrate workflow and chat with the AI director */
export interface DirectorNodeData {
  /** Optional context for the conversation */
  in_context?: string
  /** Director response text */
  out_response?: string
  /** Crew configuration for sub-agents */
  out_crew?: DirectorCrewDict
  /** pending_tool_state */
  pending_tool_state?: DirectorPendingToolStateDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** 3D Director Stage (导演台) — a blockout editor node. The whole SceneDoc (figures, props, cameras, settings) lives in in_scene; the Director agent edits it via stage3d_apply and the user edits it in the stage panel. Captures are separate image/video nodes wired from out_captures for provenance. */
export interface DirectorStageNodeData {
  /** Stage name — shown on the node and used to name captures ("<stage name> <camera>-shot-<NN>"). */
  in_name?: string
  /** The full SceneDoc (version, settings, objects, activeCameraId). Web-owned schema (ponpon-web stage3d/types.ts); v2 keyframe `tracks` fields ride through untouched. Edited by the Director via stage3d_apply and by the user in the open stage panel — last write wins per field. */
  in_scene?: Stage3dSceneDocDict
  /** Asset URLs of captures taken from this stage, in capture order. Each capture node (image/video) is wired stage.out_captures --fromIndex=N--> capture.in_source so provenance is a real value edge, not decoration. */
  out_captures?: string[]
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Panel image with generation history */
export interface GeneratedImageWithHistoryNodeData {
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Deterministic HTML→MP4 motion graphics for title cards, lower-thirds, end-cards, kinetic captions, and other structured video content. Uses HeyGen's HyperFrames renderer locally — no diffusion model, no per-clip cost. */
export interface HyperframeRendererNodeData {
  /** Full HTML document with a #root [data-composition-id=main] container. Use data-start / data-duration / data-track-index attributes on .clip elements. Animate via window.__timelines['main'] = gsap.timeline({paused:true}). Props are substituted via {{props.key}} mustache before render. */
  in_template_html?: string
  /** JSON object as a string, parsed by the agent. Values are substituted into in_template_html via {{props.key}} mustache. Example: '{"title":"Sun Wukong","subtitle":"Episode I"}'. Stored as a string because props shape is heterogeneous per template — codegen rejects generic dict / Record<string, unknown>; the agent json.loads at runtime and surfaces parse errors as AgentResult(success=False). */
  in_props_json?: string
  /** Video, image and audio files the composition plays, staged into the render workspace in order as media/0.<ext>, media/1.<ext>, ... and referenced from the HTML by that relative path (e.g. <video src="media/0.mp4">). Set from resolved asset paths, not wired by edge. The render sandbox blocks remote media, so this is the only way a composition can include generated video. */
  in_media?: Array<string | null>
  /** Composition duration in seconds. Must match the data-duration attribute on the #root element. */
  in_duration_seconds?: number
  /** Output aspect ratio. Sets the width/height pair given to the renderer. */
  in_aspect_ratio?: string
  /** Output resolution band. 1080p = 1920×1080 at 16:9 (and scaled equivalents for other aspects). */
  in_resolution?: string
  /** Frames per second. 30 is HF's default (recommended for kinetic typography); 60 doubles render time and file size for marginal perceived gain. (No options enum — frontend PortDef.options is typed string[]; integer constraint comes from the int type alone, schema-driven UI renders a number input.) */
  in_fps?: number
  /** If true, any HF lint warning (missing @font-face, contrast under WCAG AA, etc.) fails the render with AgentResult(success=False). If false, warnings are logged and render proceeds. Default false — matches HF CLI default. */
  in_strict_lint?: boolean
  /** Optional label for the node (shown on canvas). */
  in_name?: string
  /** Rendered MP4 path relative to project root. */
  out_video?: string
  /** Combined stdout/stderr from the HF lint + validate + render. Useful for debugging template issues. */
  out_render_log?: string
  /** Probed duration of the rendered MP4 (sanity-check vs in_duration_seconds). */
  out_actual_duration_seconds?: number
  /** Number of frames in the rendered MP4. */
  out_frame_count?: number
  /** batch_pending */
  batch_pending?: number
  /** Cached p95 frame capture time from the last render; UI can show 'estimated ~X seconds' for the next run. */
  render_p95_ms?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Upload a local image file */
export interface ImageNodeData {
  /**  */
  in_file_name?: string
  /** Provenance input — wired from the node that produced this asset (e.g. director_stage.out_captures with fromIndex). Resolves to the same asset path as out_image; never used for computation. */
  in_source?: string
  /** The uploaded image */
  out_image?: string
  /** Frontend-maintained summary of the node's stacked image versions: {count, picked} (picked is 0-based). The delegated canvas (ponpon-web) stamps it whenever it mutates the frontend-owned `_canvas_versions` stack or repoints out_image (append on generation, per-asset delete, version pick). Read server-side by the Director's version-awareness summary (core/version_summary.py); never written by backend agents. */
  versions_meta?: VersionsMetaDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate images from text prompts */
export interface ImageGeneratorNodeData {
  /** Optional reference image to guide the generation */
  in_images?: Array<string | null>
  /** Remote reference image URLs the delegated host attaches to the generation request (ponpon-web build-flow-generation-request.ts reads this field into payload imageUrls). Machine-owned seam: the delegated-revision fold writes the picked image here as the EDIT TARGET reference and clears it when the revision is consumed. Do not set manually. */
  in_ref_images?: string[]
  /** Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies. */
  in_upstream?: UpstreamContextDict
  /** Storyboard decompose contract (ENG-6501): {role: 'storyboard_grid', storyboard_group_id, grid_index, grid_count, grid_layout, grid_beats, scene_id, panel_offset, group_node_id, ref_node_ids, style, clip_mode}. Written once at node creation by create_storyboard_decomposed; read by finalize_storyboard. Do not repurpose. */
  in_storyboard_meta?: StoryboardDecomposeMetaDict
  /** Optional label for the generator node */
  in_name?: string
  /** Text description of the image to generate */
  in_prompt?: string
  /** Aspect ratio for the generated image */
  in_aspect_ratio?: string
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** Output resolution quality */
  in_quality?: string
  /** Image generation model */
  in_model?: string
  /** Designer node IDs for self-wiring reference edges */
  in_panel_refs?: string[]
  /** When True, store in_image directly (passthrough mode) */
  in_update?: boolean
  /** Incoming panel image from storyboard */
  in_image?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Video file path (RelativePath) from upstream video generator */
  in_video?: string
  /** Which frame to extract: first, last, or integer string (0-indexed) */
  in_frame?: string
  /** When true, skip image generation and extract frame from in_video */
  in_get_frame?: boolean
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** The generated image */
  out_generated_image?: GeneratedImageWithHistory
  /** Current selected generated image */
  out_image?: string
  /** batch_pending */
  batch_pending?: number
  /** Frontend-maintained summary of the node's stacked image versions: {count, picked} (picked is 0-based). The delegated canvas (ponpon-web) stamps it whenever it mutates the frontend-owned `_canvas_versions` stack or repoints out_image (append on generation, per-asset delete, version pick). Read server-side by the Director's version-awareness summary (core/version_summary.py); never written by backend agents. */
  versions_meta?: VersionsMetaDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Design a location/background with reference image */
export interface LocationDesignerNodeData {
  /** Optional reference image to guide the visual design */
  in_images?: Array<string | null>
  /** Remote reference image URLs the delegated host attaches to the generation request (ponpon-web build-flow-generation-request.ts reads this field into payload imageUrls). Machine-owned seam: the delegated-revision fold writes the picked image here as the EDIT TARGET reference and clears it when the revision is consumed. Do not set manually. */
  in_ref_images?: string[]
  /** Name of the location being designed */
  in_name?: string
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** Time of day for the scene */
  in_time_of_day?: string
  /** Weather condition for the scene */
  in_weather?: string
  /** Describe the location, atmosphere, key elements... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Location name (mirrors in_name for downstream label edges) */
  out_name?: string
  /** Generated location reference image */
  out_location_image?: LocationAsset
  /** Location metadata including name, style, time, and weather */
  out_metadata?: LocationMetadataDict
  /** Current selected location image */
  out_image?: string
  /** batch_pending */
  batch_pending?: number
  /** picked_variant_index */
  picked_variant_index?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Visual group container for organizing nodes */
export interface NodeGroupNodeData {
  /** Display label for the group */
  in_label?: string
  /** IDs of child nodes contained in this group. Null entries represent empty gap slots left by drag-out; use Rearrange to compact. */
  in_child_node_ids?: Array<string | null>
  /** Child arrangement mode: horizontal (single row), vertical (single column), or auto (grid) */
  in_layout_mode?: string
  /** Predefined background color key for the group container */
  in_bg_color?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Design an object/artifact with reference image */
export interface ObjectDesignerNodeData {
  /** Optional reference image to guide the visual design */
  in_images?: Array<string | null>
  /** Remote reference image URLs the delegated host attaches to the generation request (ponpon-web build-flow-generation-request.ts reads this field into payload imageUrls). Machine-owned seam: the delegated-revision fold writes the picked image here as the EDIT TARGET reference and clears it when the revision is consumed. Do not set manually. */
  in_ref_images?: string[]
  /** Name of the object being designed */
  in_name?: string
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** Describe the object appearance, material, details... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** Object name (mirrors in_name for downstream label edges) */
  out_name?: string
  /** Generated object reference image */
  out_object_image?: ObjectAsset
  /** Object metadata */
  out_metadata?: ObjectMetadataDict
  /** Current selected object image */
  out_image?: string
  /** batch_pending */
  batch_pending?: number
  /** picked_variant_index */
  picked_variant_index?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Load panel action, dialogue, and metadata */
export interface PanelSourceNodeData {
  /** The existing panel image */
  out_image?: string
  /** The action/script description */
  out_action?: string
  /** IDs of characters appearing in this panel */
  out_character_ids?: string[]
  /** Character expressions, poses, positions */
  out_appearances?: Array<{ character_id: string; expression?: string; pose?: string; position?: string }>
  /** Dialogue lines in this panel */
  out_dialogue?: Array<{ speaker: string; text: string; type?: string }>
  /** Dialogue formatted as TTS script */
  out_script?: string
  /** Shot type, angle, and focus settings */
  out_composition?: CompositionDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Enter your story prompt for generation */
export interface PromptInputNodeData {
  /** The story prompt text */
  out_prompt?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Stitches a generative video clip + audio track + brand outro card into a final ad MP4. Calls the ads-renderer sidecar service (Remotion + Chromium). Used by the ads pipeline; not for non-ads workflows (see docs/drafts/ai-ads-pipeline-plan.md §3.2.3). */
export interface RemotionComposerNodeData {
  /** The generative video clip to stitch (typically from video_generator running Seedance ref-to-video). */
  in_clip?: string
  /** Ordered clips for multi-clip tiers (30s = 2x15s FIRST_LAST). The composer concatenates them (ffmpeg re-encode) before the Remotion render. When present, takes precedence over in_clip. */
  in_clips?: Array<string | null>
  /** Dialogue audio (typically from speech_generator). Plays under the clip portion; not played over the end card. */
  in_audio?: string
  /** Displayed prominently on the end card. */
  in_brand_name?: string
  /** Displayed beneath the brand name on the end card. */
  in_tagline?: string
  /** Voiceover caption lines rendered as burned-in captions by the composition. The composer agent times each line proportionally to its length across the measured audio duration. Empty/absent = no captions. */
  in_captions?: AdCaptionsDict
  /** Which Remotion composition to invoke. Must match a <Composition id> registered in services/ads-renderer/src/index.tsx (Remotion IDs use hyphens, not underscores). */
  in_composition_id?: string
  /** Output aspect. Phase 0/1 ships 9:16 only; 3:4 and 16:9 land in Phase 1.5 with explicit options-list expansion. The agent's _ASPECT_DIMS table accepts all three, but the canvas dropdown only offers 9:16 so users don't pick an unsupported aspect. */
  in_aspect?: string
  /** Duration of the source clip in seconds. Used by the composition to schedule the end card after the clip. */
  in_clip_duration_seconds?: number
  /** Optional node label (canvas only). */
  in_name?: string
  /** Stitched, aspect-correct ad MP4 saved under the project's runtime assets. */
  out_video?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** All-in-one agent that generates panels, transitions, dialogue, and music moods from story context */
export interface ScreenplayWriterNodeData {
  /** Story context and synopsis for screenplay generation */
  in_story_context?: StoryContextDict
  /** Character reference sheets */
  in_characters?: Array<string | null>
  /** Location reference images */
  in_locations?: Array<string | null>
  /** Optional user-provided script or outline */
  in_user_script?: string
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** 9 panel descriptions */
  out_panels?: Array<{ panel_id: string; description: string; characters?: string[]; location?: string }>
  /** 8 transition specs between panels */
  out_transitions?: Array<{ type: string; description: string; from_panel?: string; to_panel?: string }>
  /** 8 dialogue entries with voice text and character */
  out_dialogue?: Array<{ character: string; text: string; emotion?: string; scene_number?: number; type?: string; voice_role_id?: string }>
  /** 8 music prompt strings */
  out_music_prompts?: string[]
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Interactive conversational story writer */
export interface ScriptWriterNodeData {
  /** Story prompt or instructions */
  in_prompt?: string
  /** The project's visual style / look (free-form descriptor or a style id, e.g. 'Pixar-style 3D feature animation — warm, rounded, soft global illumination', 'photoreal', 'gritty noir'). This is the master-doc style source: the screenplay's tone agrees with it, and the Director applies the SAME value to every designer/storyboard/video node. Empty = look-neutral. */
  in_style?: string
  /** Selected model variant: gemini, claude, or gpt */
  in_active_model?: string
  /** Project or scene name */
  in_name?: string
  /** Director's creative guidance composed from user Q&A — tone, structure, pacing, and other creative direction */
  in_director_instruction?: string
  /** When true, the Script Writer only reformats the user prompt into screenplay structure without adding, modifying, or removing storyline content */
  in_format_only?: boolean
  /** Enable Gemini model for screenplay generation */
  in_gemini?: boolean
  /** Enable Claude model for screenplay generation */
  in_claude?: boolean
  /** Enable GPT model for screenplay generation */
  in_gpt?: boolean
  /** Character names */
  in_characters?: Array<string | null>
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Optional target total duration in seconds; used to compute suggested scene count. Director should set this from the user's duration choice (30s=30, 30s-1min=60, 1-2min=120, 2-5min=240, or a custom value). */
  in_target_duration_s?: number
  /** How the screenplay ends. 'resolved' (default): the last scene answers the question the first scene asked. 'cliffhanger': the screenplay is one episode of a serial, so the last scene opens a new unanswered question and the central conflict stays open. The Director sets 'cliffhanger' for episodes and short drama. Ignored in format-only mode, where the user's content is fixed. */
  in_ending?: string
  /** Script review feedback history */
  in_review_history?: Array<{ feedback: string; round: number; accepted?: boolean; attempt?: number }>
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior screenplay + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Generated script content */
  out_script?: string
  /** Path to saved script file */
  out_script_path?: string
  /** Structured screenplay (array of scene objects with typed entries) */
  out_screenplay?: Array<{ scene_number: number; location: string; interior_exterior: string; characters: string[]; entries: Array<Record<string, string>>; estimated_duration_s?: number; beat_type?: string; energy?: string; transition_out?: { beat: string; duration_s?: number }; music_theme?: string; sequence_index?: number; sequence_title?: string }>
  /** Extracted dialogue entries with character, emotion, and text */
  out_dialogue?: Array<{ character: string; text: string; emotion?: string; scene_number?: number; type?: string; voice_role_id?: string }>
  /** Reusable narrator, system, and internal-monologue voice roles referenced by screenplay entries */
  out_voice_roles?: VoiceRoleDict[]
  /** Resolved TTS voice profiles for narrator, system, title-card, and internal-monologue roles. Profile name matches voice_role_id. */
  out_voice_profiles?: VoiceProfileDict[]
  /** Extracted action/staging direction entries per scene */
  out_action_lines?: Array<{ scene_number: number; text: string }>
  /** Deduplicated list of character names appearing in the screenplay */
  out_characters?: string[]
  /** Music mood/genre cue entries per scene */
  out_music_cues?: Array<{ scene_number: number; text: string }>
  /** Sound effect entries per scene */
  out_sfx?: Array<{ scene_number: number; text: string }>
  /** Raw ScreenplayResult JSON from Gemini */
  out_gemini?: ScreenplayResultDict
  /** Raw ScreenplayResult JSON from Claude Opus 4 */
  out_claude?: ScreenplayResultDict
  /** Raw ScreenplayResult JSON from GPT-4o */
  out_gpt?: ScreenplayResultDict
  /** Extracted location names from screenplay */
  out_locations?: string[]
  /** Which model variant was selected (gemini, claude, or gpt) */
  out_active_model?: string
  /** Number of scenes in the generated screenplay */
  out_scene_count?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Group node for short video production with storyboard grid and horizontal panel layout */
export interface ShortVideoGroupNodeData {
  /** Display label for the group */
  in_label?: string
  /** Whether the group is collapsed */
  in_collapsed?: boolean
  /** Path to the storyboard grid image */
  in_storyboard_path?: string
  /** Reference image for connected edges */
  in_image?: string
  /** IDs of child panel nodes */
  in_child_node_ids?: string[]
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Makes the subject of a photo sing AND dance a song — a pet, a person, a drawing. The photo is used as-is (no image generation); the song is either the user's audio or an original one generated from lyrics. Runs on the self-hosted MiniMax-H3 reference-to-video model with the song as reference audio, so the subject performs THAT song in time; the delivered clip carries the original song as its soundtrack. Up to 60 seconds, rendered as <=12 s scenes and cross-dissolved together: give in_scenes to move the subject through a little story (new place and business each scene, same animal), or leave it empty to stay in the photo's own setting. */
export interface SingingPortraitNodeData {
  /** The photo whose subject will sing. Used as-is as the identity reference: a clear, front-facing subject with a visible mouth works best. */
  in_image?: string
  /** The song to sing (mp3/wav/m4a/flac). Leave empty to generate an original song from in_lyrics and in_song_style. Only upload audio the user has the rights to. */
  in_audio?: string
  /** Where in the song the clip starts, in seconds. Pick the hook or chorus of an uploaded song; ignored for a generated song, which is written to the clip's length. */
  in_audio_start_s?: number
  /** Lyrics for a generated song, used only when in_audio is empty. Singable and sized to the clip: two to four lines per 12 seconds (a 60-second song wants eight to twelve lines, verse and chorus). Section tags like [verse] / [chorus] are honoured. */
  in_lyrics?: string
  /** Genre and voice for a generated song, e.g. 'upbeat bubblegum pop, bright female vocal, 120 bpm'. Used only when in_audio is empty. */
  in_song_style?: string
  /** 'dance' (default): the subject sings AND dances to the beat, bouncing and swaying with the whole body. 'sing': singing with gentle head movement only. */
  in_motion?: string
  /** One line per scene, in order: where the subject is and what it is doing while singing (e.g. 'on the kitchen counter in a shower of flour, stomping paws on a toy keyboard'). The photo keeps the subject's identity; each line sets a NEW place — that is what stops a minute of video being one static room. Sized to the clip: one scene per ~12 s (a 60 s clip takes 5-6). Fewer lines than scenes repeats the last; none means every scene stays in the photo's setting. */
  in_scenes?: Array<string | null>
  /** Optional extra direction for the performance and scene, e.g. 'sunglasses on, spotlight'. Singing in time (and dancing, per in_motion) is always requested; this adds to it. */
  in_prompt?: string
  /** Clip length in seconds, 2-60. Up to 12 s is one render; longer clips are split into equal segments of at most 12 s (a 60 s clip is five), each rendered from the same photo with its slice of the song, then joined. Each segment takes a few minutes on the GPU. */
  in_duration?: number
  /** Output framing. 9:16 is the short-form default and is delivered at 1080x1920. */
  in_aspect_ratio?: string
  /** Display name for this node on the canvas. */
  in_name?: string
  /** Revision note for a rerun, e.g. 'bigger mouth movements' or 'less head motion'. Appended to the performance direction. */
  in_feedback?: string
  /** The subject singing, with the song as the soundtrack. */
  out_video?: string
  /** The exact audio the subject performs: the trimmed upload, or the generated song. Kept so a rerun or a remix uses the same take. */
  out_song?: string
  /** Resolved display name. */
  out_name?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate music, speech, or sound effects with three unified modes */
export interface SoundExpertNodeData {
  /** Display name for the node (FloatingNodeLabel) */
  in_name?: string
  /** Upstream dependency trigger */
  in_upstream?: UpstreamContextDict
  /** Free-text description of desired audio (music/sfx) */
  in_prompt?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) or revise_node before calling run_nodes to retry a completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. Appended when a revision run completes so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** Audio generation mode: music, speech, or sfx */
  in_mode?: string
  /** Duration hint as human-readable string (music/sfx only) */
  in_duration?: string
  /** Voice profile { provider, voice_id, voice_name } from CharacterDesigner (speech mode) */
  in_voice_profile?: VoiceProfileDict
  /** Dialogue script with @-mentions and timestamps (speech mode) */
  in_text?: string
  /** Audio generation model identifier */
  in_model?: string
  /** Whether to loop the audio (sfx mode) */
  in_loop?: string
  /** Lyrics generation mode for music (auto/custom/instrumental) */
  in_lyrics_mode?: string
  /** Speaker-to-voice mapping for multi-speaker narration (speech mode) */
  in_voice_map?: VoiceMapDict
  /** Scene identifier for file naming (speech mode) */
  in_scene_id?: string
  /** Panel index for ordering within a scene (speech mode) */
  in_panel_index?: number
  /** Pause duration in milliseconds between segments (speech mode) */
  in_pause_ms?: number
  /** Character name for single-speaker TTS (speech mode) */
  in_character_name?: string
  /** Generated audio */
  out_audio?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Generated audio with history and picked index */
  in_generated_audio?: SoundGeneratedAudioDict
  /** batch_pending */
  batch_pending?: number
  /** Legacy: direct path to audio file. TODO: Remove after full canvas-v2 migration */
  audio_file?: string
  /** Per-character speech segments with voice acting results */
  speech_segments?: SpeechSegmentDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate character speech or multi-voice narration */
export interface SpeechGeneratorNodeData {
  /** Speech generation mode: character_voice or narrative */
  in_mode?: string
  /** Narration script or fallback text for character voice mode */
  in_script?: string
  /** Single-speaker text for character voice mode */
  in_text?: string
  /** Character name for single-speaker TTS */
  in_character_name?: string
  /** Explicit provider voice ID override */
  in_voice_id?: string
  /** Voice profile from Character Designer */
  in_voice_profile?: VoiceProfileDict
  /** Speaker-to-voice mapping for multi-speaker narration */
  in_voice_map?: VoiceMapDict
  /** Scene identifier for file naming */
  in_scene_id?: string
  /** Panel index for ordering within a scene */
  in_panel_index?: number
  /** Pause duration in milliseconds between segments */
  in_pause_ms?: number
  /** Per-word pronunciation overrides for non-English words and proper nouns. One rule per line: 'word → pronunciation' (alias) or 'word → /IPA/' (phoneme). Example: L'Ora → LOH-rah */
  in_pronunciation_guide?: string
  /** ISO 639-1 language code (e.g. 'en', 'it', 'zh', 'ja'). Helps ElevenLabs apply correct phonetics instead of defaulting to English. Leave empty for auto-detection. */
  in_language_code?: string
  /** Generated speech audio */
  out_audio?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Waveform samples for UI display */
  out_waveform?: number[]
  /** Generated audio with history and picked index */
  out_generated_audio?: SoundGeneratedAudioDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Story shaping dimensions: premise, tone, hook, structure */
export interface StoryDirectionPreviewNodeData {
  /** premise */
  premise?: StoryDirectionFieldDict
  /** tone */
  tone?: StoryDirectionFieldDict
  /** hook */
  hook?: StoryDirectionFieldDict
  /** structure */
  structure?: StoryDirectionFieldDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate a 9-grid storyboard from a script or scene description */
export interface StoryboardDesignerNodeData {
  /** Script or scene breakdown to visualize as storyboard */
  in_script?: string
  /** Character reference sheets for visual consistency */
  in_characters?: Array<string | null>
  /** Character names from designer out_name ports */
  in_character_names?: Array<string | null>
  /** Location reference images for scene setting */
  in_locations?: Array<string | null>
  /** Location names from designer out_name ports */
  in_location_names?: Array<string | null>
  /** Object reference images for props and items */
  in_objects?: Array<string | null>
  /** Object names from designer out_name ports */
  in_object_names?: Array<string | null>
  /** Optional reference image to guide storyboard generation */
  in_image?: string
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** Number of panels, laid out in the tightest square grid for N (4 -> 2x2, 9 -> 3x3, 16 -> 4x4; non-square counts decompose into the tightest fitting square grids with no empty cells). Sized per scene by the Director; default 9 is a standard 3x3 scene, not a hard rule. */
  in_panel_count?: number
  /** Optional storyboard aspect ratio override. When unset, uses the project aspect ratio. */
  in_aspect_ratio?: string
  /** Scene identifier for the storyboard */
  in_scene_id?: string
  /** Location for the scene */
  in_location?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** How to deliver spoken character dialogue.  'tts_remix' (default) generates TTS audio via ElevenLabs/Sunra and remixes it onto the rendered video — voice IDs stay locked across clips. 'seedance_inline' bakes the dialogue into a caption-band reference image and lets Seedance generate dialogue + lip sync in one pass — voice timbre is best-effort across clips but lip sync is exact. */
  in_dialogue_mode?: string
  /** History of generated 9-panel storyboard grid images (latest is current) */
  out_storyboard_grid?: string[]
  /** Storyboard metadata including beat descriptions */
  out_metadata?: StoryboardMetadataDict
  /** Beat descriptions per panel */
  out_beats?: string[]
  /** Per-panel list of designer node IDs */
  out_panel_refs?: string[][]
  /** Cropped panel image paths */
  out_images?: string[]
  /** Per-grid concatenated beat descriptions for grid preview node prompts */
  out_grid_descriptions?: string[]
  /** picked_storyboard_index */
  picked_storyboard_index?: number
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate a 9-grid storyboard without per-panel enhancement */
export interface StoryboardNoEnhanceDesignerNodeData {
  /** Script or scene breakdown to visualize */
  in_script?: string
  /** Character reference sheets */
  in_characters?: Array<string | null>
  /** Character names from designer out_name ports */
  in_character_names?: Array<string | null>
  /** Location reference images */
  in_locations?: Array<string | null>
  /** Location names from designer out_name ports */
  in_location_names?: Array<string | null>
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** Number of panels, laid out in the tightest square grid for N (4 -> 2x2, 9 -> 3x3, 16 -> 4x4; non-square counts decompose into the tightest fitting square grids with no empty cells). Sized per scene by the Director; default 9 is a standard 3x3 scene, not a hard rule. */
  in_panel_count?: number
  /** Scene identifier */
  in_scene_id?: string
  /** Location for the scene */
  in_location?: string
  /** Image generation model */
  in_model?: string
  /** Relative path to 9-grid image */
  out_storyboard_grid?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** A text input with editable title */
export interface TextNodeData {
  /** Text input from another node */
  in_input?: string
  /** The text content */
  out_text?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Upload a local video file */
export interface VideoNodeData {
  /**  */
  in_file_name?: string
  /** Provenance input — wired from the node that produced this asset (e.g. director_stage.out_captures with fromIndex). Resolves to the same asset path as out_video; never used for computation. */
  in_source?: string
  /** The uploaded video */
  out_video?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Edit videos: stitch clips, add audio, or trim duration */
export interface VideoEditorNodeData {
  /** Multiple video clips to stitch together (in order) */
  in_videos?: Array<string | null>
  /** Audio files to add to video */
  in_audios?: Array<string | null>
  /** Single audio file for add_audio operation */
  in_audio?: string
  /** Edit operation mode */
  in_mode?: string
  /** Output file name */
  in_output_name?: string
  /** Trim start time */
  in_start?: number
  /** Trim end time */
  in_end?: number
  /** Audio volume */
  in_volume?: number
  /** Timeline render configuration. Shape: { operation: 'timeline_render', timeline: { clips: [{ id?, source_path, start_time?, end_time?, order?, speed?, start_offset?, track_index?, volume?, muted?, fade_out_s?, fade_in_s? }], audio_tracks?: [{ source_path, start_time?, end_time?, volume?, role?: 'original'|'replacement'|'sfx', start_offset?, speed?, track_index? }], video_tracks_meta?: [{ track_index, muted? }], audio_tracks_meta?: [{ track_index, muted? }], total_duration?, video_track_count?, audio_track_count?, magnet_enabled? } }. To mute audio under specific clips, split the audio into multiple audio_tracks entries with start_time/end_time covering only the desired ranges (like splitting a clip in CapCut). */
  in_timeline_config?: TimelineConfigDict
  /** Name chosen in the Export to Download confirm sheet for the new Video node. Transient transport — written by the frontend just before executeNode and consumed by the backend agent. */
  in_export_name?: string
  /** Optional human-readable label for the video_editor node — shown on the canvas card. Written when an editor was auto-created (e.g. 'scene_1 - Final cut') by the removed Director stitch pipeline; kept so legacy nodes keep deserializing. */
  in_name?: string
  /** Edited video output */
  out_video?: string
  /** last_export_node_id */
  last_export_node_id?: string
  /** When true (default), edits to track-0 video clips re-pack the track left-to-right with no gaps after commit. */
  magnet_enabled?: boolean
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate video clips from prompts and reference images, with optional audio remix */
export interface VideoGeneratorNodeData {
  /** Video generation mode */
  in_mode?: string
  /** Scene identifier for organizing clips */
  in_scene_id?: string
  /** Clip number within the scene */
  in_clip_number?: number
  /** Reference/first-frame images for generation */
  in_images?: Array<string | null>
  /** Optional audio track to bake into the video */
  in_audio?: string
  /** Describe the video action and motion */
  in_motion_prompt?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) or revise_node before calling run_nodes to retry a completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. Appended when a revision run completes so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** Broader scene context for coherent generation */
  in_scene_context?: string
  /** Video duration in seconds */
  in_duration?: number
  /** Structured per-line dialogue/voiceover for voice acting. Voiceover entries may set voice_role_id for narrator-specific voice lookup. */
  in_dialogue_prompt?: Array<{ clip_index: number; voice_text: string; voice_character: string; start_s: number; end_s: number; type?: string; voice_role_id?: string }>
  /** Video generation model */
  in_model?: string
  /** Video aspect ratio */
  in_aspect_ratio?: string
  /** Video output resolution */
  in_resolution?: string
  /** Whether to generate audio remix after video generation */
  in_generate_audio?: boolean
  /** TTS backend for audio remix (elevenlabs or gemini) */
  in_tts_provider?: string
  /** Voice profiles from connected character designers or manually configured narrator profiles. Profile provider should match the selected TTS provider, and profile name should match a character label or narrator voice_role_id. */
  in_voice_profiles?: Array<VoiceProfileDict | null>
  /** TTS voice tuning parameters (stability, similarity_boost, style, speed) */
  in_voice_settings?: VoiceSettingsDict
  /** Optional label for the video node */
  in_name?: string
  /** Character name to resolved voice display name mapping (from voice acting) */
  in_resolved_voice_map?: ResolvedVoiceMapDict
  /** Full audio remix editor state: groups of tracks with positions, highlights, order, and optional narrator voice_role_id. Set by user via Audio Remix modal or by Director agent. */
  in_audio_remix_config?: AudioRemixConfigDict
  /** How to deliver spoken character dialogue.  'tts_remix' (default) generates TTS audio via ElevenLabs/Sunra and remixes it onto the rendered video — voice IDs stay locked across clips. 'seedance_inline' bakes the dialogue into a caption-band reference image and lets Seedance generate dialogue + lip sync in one pass — voice timbre is best-effort across clips but lip sync is exact. */
  in_dialogue_mode?: string
  /** Optional per-clip physics / visual consistency guidance appended to the motion prompt as a <style_anchor> block.  Accepts either a built-in library key ('cyberpunk_hoverbike', 'noir_grounded', 'anime_school') or any free-text anchor.  Use to prevent per-clip hallucinations (e.g. hoverbike floating above building height, anachronistic medieval physics).  Empty by default — no anchor block emitted. */
  in_style_anchor?: string
  /** Storyboard decompose contract (ENG-6501): {role: 'storyboard_clip', storyboard_group_id, clip_index}. Written once at clip creation by finalize_storyboard; identity marker for idempotent re-finalize. Do not repurpose. */
  in_storyboard_meta?: StoryboardDecomposeMetaDict
  /** Generated video clip with metadata */
  out_generated_video?: GeneratedVideoWithHistory
  /** Video with replaced dialogue audio */
  out_remixed_video?: string
  /** Mixed audio track (ducked original + replacement TTS) */
  out_replacement_mix?: string
  /** Per-line TTS audio segments with versioned paths, timing, emotion, and optional narrator voice_role_id */
  out_tts_segments?: Array<{ character: string; text: string; start_s: number; end_s: number; index?: number; audio_path?: string; duration_s?: number; path?: string; original_path?: string; tts_end_s?: number; emotion?: string; status?: string; type?: string; voice_role_id?: string; versions?: Array<{ label: string; path: string }> }>
  /** Default audio remix config auto-generated after each voice acting run. Used as the Reset target in the Audio Remix modal. */
  out_audio_remix_baseline?: AudioRemixConfigDict
  /** Dialogue entries auto-extracted from the motion prompt when no explicit in_dialogue_prompt is connected */
  out_auto_dialogue?: Array<{ clip_index: number; voice_text: string; voice_character: string; start_s: number; end_s: number; type?: string; voice_role_id?: string }>
  /** Detected speech regions with timestamps and confidence */
  out_speech_windows?: Array<{ text?: string; start_s: number; end_s: number; confidence: number }>
  /** The timed prompt sent to Veo */
  out_video_prompt?: string
  /** Video duration in seconds */
  out_video_duration?: number
  /** Reconciled dialogue data from voice acting pipeline, including optional narrator voice_role_id */
  out_dialogue?: Array<{ character: string; intended_text: string; actual_text: string; replacement_text: string; start_s: number; end_s: number; duration_s: number; emotion: string; intensity: number; status: string; line_type: string; voice_role_id?: string }>
  /** Current selected generated video */
  out_video?: string
  /** voice_acting_status */
  voice_acting_status?: string
  /** segment_index */
  segment_index?: number
  /** batch_pending */
  batch_pending?: number
  /** Legacy: video thumbnail path. TODO: Remove after full canvas-v2 migration */
  thumbnail?: string
  /** Whether this node is rendered inside a group node */
  is_inside_group?: boolean
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Collapsible group container for webtoon panels arranged vertically */
export interface WebtoonGroupNodeData {
  /** Scene identifier (e.g., ch1_s2) */
  in_scene_id?: string
  /** Display label (e.g., Chapter 1, Scene 2) */
  in_label?: string
  /** Whether the group is collapsed (internal, managed by UI toggle) */
  in_collapsed?: boolean
  /** IDs of child panel nodes */
  in_child_node_ids?: string[]
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate a webtoon page with multiple sub-panels and text bubbles */
export interface WebtoonPanelGeneratorNodeData {
  /** Storyboard panel thumbnails + character/location reference images */
  in_images?: Array<string | null>
  /** Combined visual description for the page (fallback if beats not provided) */
  in_prompt?: string
  /** List of beat descriptions for sub-panels on this page */
  in_beats?: Array<string | null>
  /** Structured dialogue entries for text bubble overlay */
  in_dialogue?: Array<WebtoonDialogueDict | null>
  /** Page position in the scene (0-based) */
  in_panel_index?: number
  /** Page aspect ratio */
  in_aspect_ratio?: string
  /** Panel layout type for page composition */
  in_layout?: string
  /** Free-form visual style descriptor. Any style the user asks for (e.g. 'Pixar-style 3D', 'gritty photoreal', 'ukiyo-e woodblock') or a named style-skill id (which brings curated reference images). Empty = look-neutral. */
  in_style?: string
  /** Image generation model. Default matches the backend _WEBTOON_DEFAULT_MODEL so the persisted id is consistent; the delegated host reads this instead of a hardcoded fallback. */
  in_model?: string
  /** Page name */
  in_name?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<{ round: number; feedback: string; applied_at: string }>
  /** Webtoon page with sub-panels and text bubbles */
  out_panel_image?: GeneratedImageWithHistory
  /** Current selected generated page image as a plain project-relative path. Resolvable pointer for downstream edges (out_panel_image is a map/history the delegated host may write as a JSON string, which the image-history parser can't resolve). */
  out_image?: string
  /** bubbles */
  bubbles?: Array<{ panel: number; type: string; text: string; speaker?: string; x: number; y: number; width: number; height: number }>
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

export type AnyNodeData = AudioNodeData | BrandFilmNodeData | CaptionerNodeData | CharacterDesignerNodeData | DebugHangNodeData | DirectorNodeData | DirectorStageNodeData | GeneratedImageWithHistoryNodeData | HyperframeRendererNodeData | ImageNodeData | ImageGeneratorNodeData | LocationDesignerNodeData | NodeGroupNodeData | ObjectDesignerNodeData | PanelSourceNodeData | PromptInputNodeData | RemotionComposerNodeData | ScreenplayWriterNodeData | ScriptWriterNodeData | ShortVideoGroupNodeData | SingingPortraitNodeData | SoundExpertNodeData | SpeechGeneratorNodeData | StoryDirectionPreviewNodeData | StoryboardDesignerNodeData | StoryboardNoEnhanceDesignerNodeData | TextNodeData | VideoNodeData | VideoEditorNodeData | VideoGeneratorNodeData | WebtoonGroupNodeData | WebtoonPanelGeneratorNodeData

/** Backend type to interface type mapping */
export type NodeDataMap = {
  'audio': AudioNodeData
  'brand_film': BrandFilmNodeData
  'captioner': CaptionerNodeData
  'character_designer': CharacterDesignerNodeData
  'debug_hang': DebugHangNodeData
  'director': DirectorNodeData
  'director_stage': DirectorStageNodeData
  'generated_image_with_history': GeneratedImageWithHistoryNodeData
  'hyperframe_renderer': HyperframeRendererNodeData
  'image': ImageNodeData
  'image_generator': ImageGeneratorNodeData
  'location_designer': LocationDesignerNodeData
  'node_group': NodeGroupNodeData
  'object_designer': ObjectDesignerNodeData
  'panel_source': PanelSourceNodeData
  'prompt_input': PromptInputNodeData
  'remotion_composer': RemotionComposerNodeData
  'screenplay_writer': ScreenplayWriterNodeData
  'script_writer': ScriptWriterNodeData
  'short_video_group': ShortVideoGroupNodeData
  'singing_portrait': SingingPortraitNodeData
  'sound_expert': SoundExpertNodeData
  'speech_generator': SpeechGeneratorNodeData
  'story_direction_preview': StoryDirectionPreviewNodeData
  'storyboard_designer': StoryboardDesignerNodeData
  'storyboard_no_enhance_designer': StoryboardNoEnhanceDesignerNodeData
  'text': TextNodeData
  'video': VideoNodeData
  'video_editor': VideoEditorNodeData
  'video_generator': VideoGeneratorNodeData
  'webtoon_group': WebtoonGroupNodeData
  'webtoon_panel_generator': WebtoonPanelGeneratorNodeData
}

// ---------------------------------------------------------------------------
// Generated YDoc data-field readers/writers
// ---------------------------------------------------------------------------

export const YDOC_STRUCTURAL_KEYS = new Set<string>([
  'type', 'status', 'label',
  'x', 'y', 'tainted', 'width', 'height',
  'parentNode',
])

const YDOC_LEGACY_FIELD_RENAMES: Record<string, string> = {
  resolved_voice_map: 'in_resolved_voice_map',
  generated_audio: 'in_generated_audio',
  review_history: 'in_review_history',
}

const YDOC_HISTORY_POINTER_FIELDS: Record<string, string> = {
  out_generated_image: 'out_image',
  out_generated_video: 'out_video',
}

const YDOC_DESIGNER_IMAGE_FIELDS = new Set<string>([
  'out_character_sheet',
  'out_location_image',
  'out_object_image',
])

function _isYDocWriteObject(value: YDocWriteValue): value is YDocWriteRecord {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    !(value instanceof Y.Map) &&
    !(value instanceof Y.Array) &&
    !(typeof File !== 'undefined' && value instanceof File)
  )
}

function _toYDocValue(value: YDocWriteValue): YDocValue {
  if (value === null || value === undefined) return value
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value
  if (value instanceof Y.Map || value instanceof Y.Array) return value
  if (typeof File !== 'undefined' && value instanceof File) return undefined
  if (Array.isArray(value)) return value.map((item) => _toYDocValue(item))

  const out: { [key: string]: YDocValue } = {}
  for (const [key, item] of Object.entries(value)) {
    out[key] = _toYDocValue(item)
  }
  return out
}

function _serializeYDocFieldValue(value: YDocWriteValue): YDocValue {
  if (value === null || value === undefined) return value
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value
  try { return JSON.stringify(value) } catch { return String(value) }
}

function _toYDocIndex(value: YDocWriteValue): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value)
    if (Number.isFinite(parsed)) return parsed
  }
  return undefined
}

function _writeYDocMapField(
  ynode: Y.Map<YDocValue>,
  field: string,
  value: YDocWriteValue,
): boolean {
  if (!_isYDocWriteObject(value)) {
    const serialized = _serializeYDocFieldValue(value)
    if (ynode.get(field) === serialized) return false
    ynode.set(field, serialized)
    return true
  }

  if ('history' in value || (field in YDOC_HISTORY_POINTER_FIELDS && 'picked_index' in value)) {
    const history = Array.isArray(value.history) ? value.history : []
    const pickedIndex = _toYDocIndex(value.picked_index) ?? 0
    const existing = ynode.get(field)
    if (existing instanceof Y.Map) {
      if (existing.get('picked_index') === pickedIndex) return false
      existing.set('picked_index', pickedIndex)
      return true
    }
    const yMap = new Y.Map<YDocValue>()
    const yArr = new Y.Array<YDocValue>()
    yArr.push(history.map((item) => typeof item === 'string' ? item : JSON.stringify(item)))
    yMap.set('history', yArr)
    yMap.set('picked_index', pickedIndex)
    ynode.set(field, yMap)
    return true
  }

  const existing = ynode.get(field)
  if (existing instanceof Y.Map) {
    let written = false
    for (const oldKey of [...existing.keys()]) {
      if (!(oldKey in value)) {
        existing.delete(oldKey)
        written = true
      }
    }
    for (const [entryKey, entryValue] of Object.entries(value)) {
      const serialized = _toYDocValue(entryValue)
      if (existing.get(entryKey) !== serialized) {
        existing.set(entryKey, serialized)
        written = true
      }
    }
    return written
  }

  const yMap = new Y.Map<YDocValue>()
  for (const [entryKey, entryValue] of Object.entries(value)) {
    yMap.set(entryKey, _toYDocValue(entryValue))
  }
  ynode.set(field, yMap)
  return true
}

function _writeYDocArrayField(
  ynode: Y.Map<YDocValue>,
  field: string,
  value: YDocWriteValue,
): boolean {
  let arr = Array.isArray(value)
    ? value.map((item) => _toYDocValue(item))
    : (value != null ? [_toYDocValue(value)] : [])
  if (field === 'in_child_node_ids') {
    const seen = new Set<string>()
    arr = arr.filter((id) => {
      if (id === null) return true
      if (typeof id === 'string' && seen.has(id)) return false
      if (typeof id === 'string') seen.add(id)
      return true
    })
  }
  const existing = ynode.get(field)
  if (existing instanceof Y.Array) {
    const current = existing.toArray()
    if (current.length === arr.length && current.every((item, index) => item === arr[index])) return false
    existing.delete(0, existing.length)
    existing.push(arr)
    return true
  }
  const yArr = new Y.Array<YDocValue>()
  yArr.push(arr)
  ynode.set(field, yArr)
  return true
}

function _writeYDocDesignerJsonField(
  _ynode: Y.Map<YDocValue>,
  _field: string,
  _value: YDocWriteValue,
): boolean {
  // CRDT race prevention: designer asset JSON fields are backend-authored
  // only. Writing the full JSON string from the frontend races with the
  // backend's emit_outputs in production (multi-instance Yjs sync latency),
  // causing last-writer-wins to discard newly-appended variant history.
  // See Workplace #1518197933270838 for full RCA.
  return false
}

function _writeYDocPrimitiveJsonField(
  ynode: Y.Map<YDocValue>,
  field: string,
  value: YDocWriteValue,
): boolean {
  const serialized = _serializeYDocFieldValue(value)
  if (ynode.get(field) === serialized) return false
  ynode.set(field, serialized)
  return true
}

export function readYDocNodeDataFields(
  ynode: Y.Map<YDocValue>,
  backendType: string,
): Record<string, YDocValue> {
  const dataRaw: Record<string, YDocValue> = {}
  const desers = YDOC_DESERIALIZERS[backendType] ?? {}
  for (const key of ynode.keys()) {
    if (YDOC_STRUCTURAL_KEYS.has(key)) continue
    if (key.startsWith('_')) continue
    const raw = ynode.get(key)
    const newKey = YDOC_LEGACY_FIELD_RENAMES[key]
    if (newKey && !(newKey in dataRaw)) {
      const deser = desers[newKey]
      dataRaw[newKey] = deser ? deser(raw) : raw
      continue
    }
    const deser = desers[key]
    dataRaw[key] = deser ? deser(raw) : raw
  }
  return dataRaw
}

export function readYDocNodeDataRecord(
  rawRecord: Record<string, YDocValue>,
  backendType: string,
): Record<string, YDocValue> {
  const dataRaw: Record<string, YDocValue> = {}
  const desers = YDOC_DESERIALIZERS[backendType] ?? {}
  for (const [key, raw] of Object.entries(rawRecord)) {
    if (YDOC_STRUCTURAL_KEYS.has(key)) continue
    if (key.startsWith('_')) continue
    const newKey = YDOC_LEGACY_FIELD_RENAMES[key]
    if (newKey && !(newKey in dataRaw)) {
      const deser = desers[newKey]
      dataRaw[newKey] = deser ? deser(raw) : raw
      continue
    }
    const deser = desers[key]
    dataRaw[key] = deser ? deser(raw) : raw
  }
  return dataRaw
}

export function writeYDocNodeDataField(
  ynode: Y.Map<YDocValue>,
  backendType: string,
  field: string,
  value: YDocWriteValue,
): boolean {
  if (YDOC_STRUCTURAL_KEYS.has(field)) return false
  if (field.startsWith('_')) return false
  if (typeof File !== 'undefined' && value instanceof File) return false
  const spec = YDOC_NODE_FIELDS[backendType]?.[field]
  if (spec?.wireType === 'map') return _writeYDocMapField(ynode, field, value)
  if (spec?.wireType === 'array') return _writeYDocArrayField(ynode, field, value)
  if (spec?.wireType === 'json' && _isYDocWriteObject(value) && YDOC_DESIGNER_IMAGE_FIELDS.has(field)) {
    return _writeYDocDesignerJsonField(ynode, field, value)
  }
  return _writeYDocPrimitiveJsonField(ynode, field, value)
}

export function writeYDocNodeDataFields(
  ynode: Y.Map<YDocValue>,
  backendType: string,
  updates: YDocWriteRecord,
): string[] {
  const written: string[] = []
  for (const [field, value] of Object.entries(updates)) {
    if (writeYDocNodeDataField(ynode, backendType, field, value)) written.push(field)
  }
  return written
}

// ---------------------------------------------------------------------------
// Generated concrete YDoc field writers
// ---------------------------------------------------------------------------

export function writeAudioInFileName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<AudioNodeData['in_file_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'audio', 'in_file_name', value)
}

export function writeAudioOutAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<AudioNodeData['out_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'audio', 'out_audio', value)
}

export function writeBrandFilmInPlan(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['in_plan'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'in_plan', value)
}

export function writeBrandFilmInClips(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['in_clips'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'in_clips', value)
}

export function writeBrandFilmInVoiceover(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['in_voiceover'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'in_voiceover', value)
}

export function writeBrandFilmInMusic(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['in_music'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'in_music', value)
}

export function writeBrandFilmInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'in_name', value)
}

export function writeBrandFilmOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'out_video', value)
}

export function writeBrandFilmOutRenderLog(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['out_render_log'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'out_render_log', value)
}

export function writeBrandFilmOutName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<BrandFilmNodeData['out_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'brand_film', 'out_name', value)
}

export function writeCaptionerInVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['in_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'in_video', value)
}

export function writeCaptionerInLanguage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['in_language'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'in_language', value)
}

export function writeCaptionerInCaptionStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['in_caption_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'in_caption_style', value)
}

export function writeCaptionerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'in_name', value)
}

export function writeCaptionerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'in_feedback', value)
}

export function writeCaptionerOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'out_video', value)
}

export function writeCaptionerOutTranscript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['out_transcript'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'out_transcript', value)
}

export function writeCaptionerOutName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CaptionerNodeData['out_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'captioner', 'out_name', value)
}

export function writeCharacterDesignerInUpstream(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_upstream'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_upstream', value)
}

export function writeCharacterDesignerInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_images', value)
}

export function writeCharacterDesignerInRefImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_ref_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_ref_images', value)
}

export function writeCharacterDesignerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_name', value)
}

export function writeCharacterDesignerInRole(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_role'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_role', value)
}

export function writeCharacterDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_style', value)
}

export function writeCharacterDesignerInDescription(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_description'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_description', value)
}

export function writeCharacterDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_model', value)
}

export function writeCharacterDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_feedback', value)
}

export function writeCharacterDesignerInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_feedback_history', value)
}

export function writeCharacterDesignerInPronunciationGuide(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_pronunciation_guide'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_pronunciation_guide', value)
}

export function writeCharacterDesignerInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_bg_color'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_bg_color', value)
}

export function writeCharacterDesignerInVoiceDescriptor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['in_voice_descriptor'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'in_voice_descriptor', value)
}

export function writeCharacterDesignerOutName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['out_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'out_name', value)
}

export function writeCharacterDesignerOutCharacterSheet(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['out_character_sheet'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'out_character_sheet', value)
}

export function writeCharacterDesignerOutVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['out_voice_profile'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'out_voice_profile', value)
}

export function writeCharacterDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeData['out_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'character_designer', 'out_image', value)
}

export function writeDebugHangInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DebugHangNodeData['in_label'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'debug_hang', 'in_label', value)
}

export function writeDebugHangOutResult(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DebugHangNodeData['out_result'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'debug_hang', 'out_result', value)
}

export function writeDirectorInContext(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorNodeData['in_context'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'director', 'in_context', value)
}

export function writeDirectorOutResponse(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorNodeData['out_response'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'director', 'out_response', value)
}

export function writeDirectorOutCrew(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorNodeData['out_crew'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'director', 'out_crew', value)
}

export function writeDirectorStageInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorStageNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'director_stage', 'in_name', value)
}

export function writeDirectorStageInScene(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorStageNodeData['in_scene'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'director_stage', 'in_scene', value)
}

export function writeDirectorStageOutCaptures(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorStageNodeData['out_captures'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'director_stage', 'out_captures', value)
}

export function writeHyperframeRendererInTemplateHtml(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_template_html'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_template_html', value)
}

export function writeHyperframeRendererInPropsJson(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_props_json'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_props_json', value)
}

export function writeHyperframeRendererInMedia(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_media'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_media', value)
}

export function writeHyperframeRendererInDurationSeconds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_duration_seconds'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_duration_seconds', value)
}

export function writeHyperframeRendererInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_aspect_ratio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_aspect_ratio', value)
}

export function writeHyperframeRendererInResolution(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_resolution'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_resolution', value)
}

export function writeHyperframeRendererInFps(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_fps'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_fps', value)
}

export function writeHyperframeRendererInStrictLint(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_strict_lint'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_strict_lint', value)
}

export function writeHyperframeRendererInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'in_name', value)
}

export function writeHyperframeRendererOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'out_video', value)
}

export function writeHyperframeRendererOutRenderLog(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['out_render_log'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'out_render_log', value)
}

export function writeHyperframeRendererOutActualDurationSeconds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['out_actual_duration_seconds'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'out_actual_duration_seconds', value)
}

export function writeHyperframeRendererOutFrameCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<HyperframeRendererNodeData['out_frame_count'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'hyperframe_renderer', 'out_frame_count', value)
}

export function writeImageInFileName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageNodeData['in_file_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image', 'in_file_name', value)
}

export function writeImageInSource(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageNodeData['in_source'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image', 'in_source', value)
}

export function writeImageOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageNodeData['out_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image', 'out_image', value)
}

export function writeImageGeneratorInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_images', value)
}

export function writeImageGeneratorInRefImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_ref_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_ref_images', value)
}

export function writeImageGeneratorInUpstream(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_upstream'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_upstream', value)
}

export function writeImageGeneratorInStoryboardMeta(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_storyboard_meta'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_storyboard_meta', value)
}

export function writeImageGeneratorInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_name', value)
}

export function writeImageGeneratorInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_prompt', value)
}

export function writeImageGeneratorInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_aspect_ratio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_aspect_ratio', value)
}

export function writeImageGeneratorInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_style', value)
}

export function writeImageGeneratorInQuality(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_quality'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_quality', value)
}

export function writeImageGeneratorInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_model', value)
}

export function writeImageGeneratorInPanelRefs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_panel_refs'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_panel_refs', value)
}

export function writeImageGeneratorInUpdate(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_update'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_update', value)
}

export function writeImageGeneratorInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_image', value)
}

export function writeImageGeneratorInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_feedback', value)
}

export function writeImageGeneratorInVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_video', value)
}

export function writeImageGeneratorInFrame(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_frame'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_frame', value)
}

export function writeImageGeneratorInGetFrame(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_get_frame'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_get_frame', value)
}

export function writeImageGeneratorInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'in_feedback_history', value)
}

export function writeImageGeneratorOutGeneratedImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['out_generated_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'out_generated_image', value)
}

export function writeImageGeneratorOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeData['out_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'image_generator', 'out_image', value)
}

export function writeLocationDesignerInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_images', value)
}

export function writeLocationDesignerInRefImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_ref_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_ref_images', value)
}

export function writeLocationDesignerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_name', value)
}

export function writeLocationDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_style', value)
}

export function writeLocationDesignerInTimeOfDay(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_time_of_day'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_time_of_day', value)
}

export function writeLocationDesignerInWeather(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_weather'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_weather', value)
}

export function writeLocationDesignerInDescription(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_description'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_description', value)
}

export function writeLocationDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_model', value)
}

export function writeLocationDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_feedback', value)
}

export function writeLocationDesignerInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_feedback_history', value)
}

export function writeLocationDesignerInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['in_bg_color'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'in_bg_color', value)
}

export function writeLocationDesignerOutName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['out_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'out_name', value)
}

export function writeLocationDesignerOutLocationImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['out_location_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'out_location_image', value)
}

export function writeLocationDesignerOutMetadata(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['out_metadata'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'out_metadata', value)
}

export function writeLocationDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeData['out_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'location_designer', 'out_image', value)
}

export function writeNodeGroupInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeData['in_label'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'node_group', 'in_label', value)
}

export function writeNodeGroupInChildNodeIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeData['in_child_node_ids'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'node_group', 'in_child_node_ids', value)
}

export function writeNodeGroupInLayoutMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeData['in_layout_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'node_group', 'in_layout_mode', value)
}

export function writeNodeGroupInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeData['in_bg_color'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'node_group', 'in_bg_color', value)
}

export function writeObjectDesignerInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_images', value)
}

export function writeObjectDesignerInRefImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_ref_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_ref_images', value)
}

export function writeObjectDesignerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_name', value)
}

export function writeObjectDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_style', value)
}

export function writeObjectDesignerInDescription(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_description'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_description', value)
}

export function writeObjectDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_model', value)
}

export function writeObjectDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_feedback', value)
}

export function writeObjectDesignerInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'in_feedback_history', value)
}

export function writeObjectDesignerOutName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['out_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'out_name', value)
}

export function writeObjectDesignerOutObjectImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['out_object_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'out_object_image', value)
}

export function writeObjectDesignerOutMetadata(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['out_metadata'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'out_metadata', value)
}

export function writeObjectDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeData['out_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'object_designer', 'out_image', value)
}

export function writePanelSourceOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeData['out_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'panel_source', 'out_image', value)
}

export function writePanelSourceOutAction(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeData['out_action'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'panel_source', 'out_action', value)
}

export function writePanelSourceOutCharacterIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeData['out_character_ids'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'panel_source', 'out_character_ids', value)
}

export function writePanelSourceOutAppearances(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeData['out_appearances'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'panel_source', 'out_appearances', value)
}

export function writePanelSourceOutDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeData['out_dialogue'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'panel_source', 'out_dialogue', value)
}

export function writePanelSourceOutScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeData['out_script'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'panel_source', 'out_script', value)
}

export function writePanelSourceOutComposition(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeData['out_composition'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'panel_source', 'out_composition', value)
}

export function writePromptInputOutPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PromptInputNodeData['out_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'prompt_input', 'out_prompt', value)
}

export function writeRemotionComposerInClip(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_clip'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_clip', value)
}

export function writeRemotionComposerInClips(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_clips'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_clips', value)
}

export function writeRemotionComposerInAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_audio', value)
}

export function writeRemotionComposerInBrandName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_brand_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_brand_name', value)
}

export function writeRemotionComposerInTagline(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_tagline'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_tagline', value)
}

export function writeRemotionComposerInCaptions(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_captions'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_captions', value)
}

export function writeRemotionComposerInCompositionId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_composition_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_composition_id', value)
}

export function writeRemotionComposerInAspect(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_aspect'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_aspect', value)
}

export function writeRemotionComposerInClipDurationSeconds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_clip_duration_seconds'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_clip_duration_seconds', value)
}

export function writeRemotionComposerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'in_name', value)
}

export function writeRemotionComposerOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<RemotionComposerNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'remotion_composer', 'out_video', value)
}

export function writeScreenplayWriterInStoryContext(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['in_story_context'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'in_story_context', value)
}

export function writeScreenplayWriterInCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['in_characters'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'in_characters', value)
}

export function writeScreenplayWriterInLocations(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['in_locations'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'in_locations', value)
}

export function writeScreenplayWriterInUserScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['in_user_script'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'in_user_script', value)
}

export function writeScreenplayWriterInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'in_style', value)
}

export function writeScreenplayWriterOutPanels(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['out_panels'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'out_panels', value)
}

export function writeScreenplayWriterOutTransitions(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['out_transitions'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'out_transitions', value)
}

export function writeScreenplayWriterOutDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['out_dialogue'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'out_dialogue', value)
}

export function writeScreenplayWriterOutMusicPrompts(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScreenplayWriterNodeData['out_music_prompts'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'screenplay_writer', 'out_music_prompts', value)
}

export function writeScriptWriterInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_prompt', value)
}

export function writeScriptWriterInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_style', value)
}

export function writeScriptWriterInActiveModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_active_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_active_model', value)
}

export function writeScriptWriterInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_name', value)
}

export function writeScriptWriterInDirectorInstruction(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_director_instruction'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_director_instruction', value)
}

export function writeScriptWriterInFormatOnly(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_format_only'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_format_only', value)
}

export function writeScriptWriterInGemini(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_gemini'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_gemini', value)
}

export function writeScriptWriterInClaude(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_claude'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_claude', value)
}

export function writeScriptWriterInGpt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_gpt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_gpt', value)
}

export function writeScriptWriterInCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_characters'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_characters', value)
}

export function writeScriptWriterInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_feedback', value)
}

export function writeScriptWriterInTargetDurationS(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_target_duration_s'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_target_duration_s', value)
}

export function writeScriptWriterInEnding(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_ending'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_ending', value)
}

export function writeScriptWriterInReviewHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_review_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_review_history', value)
}

export function writeScriptWriterInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_feedback_history', value)
}

export function writeScriptWriterInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['in_bg_color'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'in_bg_color', value)
}

export function writeScriptWriterOutScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_script'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_script', value)
}

export function writeScriptWriterOutScriptPath(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_script_path'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_script_path', value)
}

export function writeScriptWriterOutScreenplay(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_screenplay'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_screenplay', value)
}

export function writeScriptWriterOutDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_dialogue'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_dialogue', value)
}

export function writeScriptWriterOutVoiceRoles(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_voice_roles'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_voice_roles', value)
}

export function writeScriptWriterOutVoiceProfiles(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_voice_profiles'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_voice_profiles', value)
}

export function writeScriptWriterOutActionLines(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_action_lines'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_action_lines', value)
}

export function writeScriptWriterOutCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_characters'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_characters', value)
}

export function writeScriptWriterOutMusicCues(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_music_cues'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_music_cues', value)
}

export function writeScriptWriterOutSfx(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_sfx'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_sfx', value)
}

export function writeScriptWriterOutGemini(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_gemini'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_gemini', value)
}

export function writeScriptWriterOutClaude(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_claude'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_claude', value)
}

export function writeScriptWriterOutGpt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_gpt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_gpt', value)
}

export function writeScriptWriterOutLocations(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_locations'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_locations', value)
}

export function writeScriptWriterOutActiveModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_active_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_active_model', value)
}

export function writeScriptWriterOutSceneCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeData['out_scene_count'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'script_writer', 'out_scene_count', value)
}

export function writeShortVideoGroupInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeData['in_label'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'short_video_group', 'in_label', value)
}

export function writeShortVideoGroupInCollapsed(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeData['in_collapsed'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'short_video_group', 'in_collapsed', value)
}

export function writeShortVideoGroupInStoryboardPath(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeData['in_storyboard_path'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'short_video_group', 'in_storyboard_path', value)
}

export function writeShortVideoGroupInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeData['in_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'short_video_group', 'in_image', value)
}

export function writeShortVideoGroupInChildNodeIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeData['in_child_node_ids'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'short_video_group', 'in_child_node_ids', value)
}

export function writeSingingPortraitInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_image', value)
}

export function writeSingingPortraitInAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_audio', value)
}

export function writeSingingPortraitInAudioStartS(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_audio_start_s'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_audio_start_s', value)
}

export function writeSingingPortraitInLyrics(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_lyrics'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_lyrics', value)
}

export function writeSingingPortraitInSongStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_song_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_song_style', value)
}

export function writeSingingPortraitInMotion(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_motion'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_motion', value)
}

export function writeSingingPortraitInScenes(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_scenes'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_scenes', value)
}

export function writeSingingPortraitInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_prompt', value)
}

export function writeSingingPortraitInDuration(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_duration'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_duration', value)
}

export function writeSingingPortraitInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_aspect_ratio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_aspect_ratio', value)
}

export function writeSingingPortraitInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_name', value)
}

export function writeSingingPortraitInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'in_feedback', value)
}

export function writeSingingPortraitOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'out_video', value)
}

export function writeSingingPortraitOutSong(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['out_song'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'out_song', value)
}

export function writeSingingPortraitOutName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SingingPortraitNodeData['out_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'singing_portrait', 'out_name', value)
}

export function writeSoundExpertInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_name', value)
}

export function writeSoundExpertInUpstream(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_upstream'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_upstream', value)
}

export function writeSoundExpertInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_prompt', value)
}

export function writeSoundExpertInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_feedback', value)
}

export function writeSoundExpertInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_feedback_history', value)
}

export function writeSoundExpertInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_mode', value)
}

export function writeSoundExpertInDuration(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_duration'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_duration', value)
}

export function writeSoundExpertInVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_voice_profile'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_voice_profile', value)
}

export function writeSoundExpertInText(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_text'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_text', value)
}

export function writeSoundExpertInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_model', value)
}

export function writeSoundExpertInLoop(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_loop'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_loop', value)
}

export function writeSoundExpertInLyricsMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_lyrics_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_lyrics_mode', value)
}

export function writeSoundExpertInVoiceMap(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_voice_map'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_voice_map', value)
}

export function writeSoundExpertInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_scene_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_scene_id', value)
}

export function writeSoundExpertInPanelIndex(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_panel_index'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_panel_index', value)
}

export function writeSoundExpertInPauseMs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_pause_ms'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_pause_ms', value)
}

export function writeSoundExpertInCharacterName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_character_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_character_name', value)
}

export function writeSoundExpertOutAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['out_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'out_audio', value)
}

export function writeSoundExpertOutDurationSeconds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['out_duration_seconds'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'out_duration_seconds', value)
}

export function writeSoundExpertInGeneratedAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeData['in_generated_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'sound_expert', 'in_generated_audio', value)
}

export function writeSpeechGeneratorInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_mode', value)
}

export function writeSpeechGeneratorInScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_script'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_script', value)
}

export function writeSpeechGeneratorInText(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_text'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_text', value)
}

export function writeSpeechGeneratorInCharacterName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_character_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_character_name', value)
}

export function writeSpeechGeneratorInVoiceId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_voice_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_voice_id', value)
}

export function writeSpeechGeneratorInVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_voice_profile'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_voice_profile', value)
}

export function writeSpeechGeneratorInVoiceMap(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_voice_map'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_voice_map', value)
}

export function writeSpeechGeneratorInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_scene_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_scene_id', value)
}

export function writeSpeechGeneratorInPanelIndex(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_panel_index'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_panel_index', value)
}

export function writeSpeechGeneratorInPauseMs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_pause_ms'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_pause_ms', value)
}

export function writeSpeechGeneratorInPronunciationGuide(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_pronunciation_guide'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_pronunciation_guide', value)
}

export function writeSpeechGeneratorInLanguageCode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['in_language_code'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'in_language_code', value)
}

export function writeSpeechGeneratorOutAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['out_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'out_audio', value)
}

export function writeSpeechGeneratorOutDurationSeconds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['out_duration_seconds'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'out_duration_seconds', value)
}

export function writeSpeechGeneratorOutWaveform(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['out_waveform'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'out_waveform', value)
}

export function writeSpeechGeneratorOutGeneratedAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeData['out_generated_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'speech_generator', 'out_generated_audio', value)
}

export function writeStoryboardDesignerInScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_script'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_script', value)
}

export function writeStoryboardDesignerInCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_characters'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_characters', value)
}

export function writeStoryboardDesignerInCharacterNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_character_names'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_character_names', value)
}

export function writeStoryboardDesignerInLocations(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_locations'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_locations', value)
}

export function writeStoryboardDesignerInLocationNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_location_names'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_location_names', value)
}

export function writeStoryboardDesignerInObjects(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_objects'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_objects', value)
}

export function writeStoryboardDesignerInObjectNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_object_names'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_object_names', value)
}

export function writeStoryboardDesignerInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_image', value)
}

export function writeStoryboardDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_style', value)
}

export function writeStoryboardDesignerInPanelCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_panel_count'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_panel_count', value)
}

export function writeStoryboardDesignerInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_aspect_ratio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_aspect_ratio', value)
}

export function writeStoryboardDesignerInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_scene_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_scene_id', value)
}

export function writeStoryboardDesignerInLocation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_location'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_location', value)
}

export function writeStoryboardDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_model', value)
}

export function writeStoryboardDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_feedback', value)
}

export function writeStoryboardDesignerInDialogueMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['in_dialogue_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'in_dialogue_mode', value)
}

export function writeStoryboardDesignerOutStoryboardGrid(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['out_storyboard_grid'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'out_storyboard_grid', value)
}

export function writeStoryboardDesignerOutMetadata(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['out_metadata'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'out_metadata', value)
}

export function writeStoryboardDesignerOutBeats(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['out_beats'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'out_beats', value)
}

export function writeStoryboardDesignerOutPanelRefs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['out_panel_refs'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'out_panel_refs', value)
}

export function writeStoryboardDesignerOutImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['out_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'out_images', value)
}

export function writeStoryboardDesignerOutGridDescriptions(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeData['out_grid_descriptions'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_designer', 'out_grid_descriptions', value)
}

export function writeStoryboardNoEnhanceDesignerInScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_script'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_script', value)
}

export function writeStoryboardNoEnhanceDesignerInCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_characters'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_characters', value)
}

export function writeStoryboardNoEnhanceDesignerInCharacterNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_character_names'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_character_names', value)
}

export function writeStoryboardNoEnhanceDesignerInLocations(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_locations'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_locations', value)
}

export function writeStoryboardNoEnhanceDesignerInLocationNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_location_names'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_location_names', value)
}

export function writeStoryboardNoEnhanceDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_style', value)
}

export function writeStoryboardNoEnhanceDesignerInPanelCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_panel_count'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_panel_count', value)
}

export function writeStoryboardNoEnhanceDesignerInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_scene_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_scene_id', value)
}

export function writeStoryboardNoEnhanceDesignerInLocation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_location'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_location', value)
}

export function writeStoryboardNoEnhanceDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'in_model', value)
}

export function writeStoryboardNoEnhanceDesignerOutStoryboardGrid(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeData['out_storyboard_grid'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'storyboard_no_enhance_designer', 'out_storyboard_grid', value)
}

export function writeTextInInput(
  ynode: Y.Map<YDocValue>,
  value: Exclude<TextNodeData['in_input'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'text', 'in_input', value)
}

export function writeTextOutText(
  ynode: Y.Map<YDocValue>,
  value: Exclude<TextNodeData['out_text'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'text', 'out_text', value)
}

export function writeVideoInFileName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeData['in_file_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video', 'in_file_name', value)
}

export function writeVideoInSource(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeData['in_source'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video', 'in_source', value)
}

export function writeVideoOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video', 'out_video', value)
}

export function writeVideoEditorInVideos(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_videos'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_videos', value)
}

export function writeVideoEditorInAudios(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_audios'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_audios', value)
}

export function writeVideoEditorInAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_audio', value)
}

export function writeVideoEditorInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_mode', value)
}

export function writeVideoEditorInOutputName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_output_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_output_name', value)
}

export function writeVideoEditorInStart(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_start'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_start', value)
}

export function writeVideoEditorInEnd(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_end'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_end', value)
}

export function writeVideoEditorInVolume(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_volume'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_volume', value)
}

export function writeVideoEditorInTimelineConfig(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_timeline_config'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_timeline_config', value)
}

export function writeVideoEditorInExportName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_export_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_export_name', value)
}

export function writeVideoEditorInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'in_name', value)
}

export function writeVideoEditorOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_editor', 'out_video', value)
}

export function writeVideoGeneratorInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_mode', value)
}

export function writeVideoGeneratorInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_scene_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_scene_id', value)
}

export function writeVideoGeneratorInClipNumber(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_clip_number'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_clip_number', value)
}

export function writeVideoGeneratorInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_images', value)
}

export function writeVideoGeneratorInAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_audio', value)
}

export function writeVideoGeneratorInMotionPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_motion_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_motion_prompt', value)
}

export function writeVideoGeneratorInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_feedback', value)
}

export function writeVideoGeneratorInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_feedback_history', value)
}

export function writeVideoGeneratorInSceneContext(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_scene_context'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_scene_context', value)
}

export function writeVideoGeneratorInDuration(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_duration'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_duration', value)
}

export function writeVideoGeneratorInDialoguePrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_dialogue_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_dialogue_prompt', value)
}

export function writeVideoGeneratorInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_model', value)
}

export function writeVideoGeneratorInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_aspect_ratio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_aspect_ratio', value)
}

export function writeVideoGeneratorInResolution(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_resolution'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_resolution', value)
}

export function writeVideoGeneratorInGenerateAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_generate_audio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_generate_audio', value)
}

export function writeVideoGeneratorInTtsProvider(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_tts_provider'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_tts_provider', value)
}

export function writeVideoGeneratorInVoiceProfiles(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_voice_profiles'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_voice_profiles', value)
}

export function writeVideoGeneratorInVoiceSettings(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_voice_settings'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_voice_settings', value)
}

export function writeVideoGeneratorInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_name', value)
}

export function writeVideoGeneratorInResolvedVoiceMap(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_resolved_voice_map'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_resolved_voice_map', value)
}

export function writeVideoGeneratorInAudioRemixConfig(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_audio_remix_config'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_audio_remix_config', value)
}

export function writeVideoGeneratorInDialogueMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_dialogue_mode'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_dialogue_mode', value)
}

export function writeVideoGeneratorInStyleAnchor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_style_anchor'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_style_anchor', value)
}

export function writeVideoGeneratorInStoryboardMeta(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['in_storyboard_meta'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'in_storyboard_meta', value)
}

export function writeVideoGeneratorOutGeneratedVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_generated_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_generated_video', value)
}

export function writeVideoGeneratorOutRemixedVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_remixed_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_remixed_video', value)
}

export function writeVideoGeneratorOutReplacementMix(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_replacement_mix'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_replacement_mix', value)
}

export function writeVideoGeneratorOutTtsSegments(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_tts_segments'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_tts_segments', value)
}

export function writeVideoGeneratorOutAudioRemixBaseline(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_audio_remix_baseline'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_audio_remix_baseline', value)
}

export function writeVideoGeneratorOutAutoDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_auto_dialogue'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_auto_dialogue', value)
}

export function writeVideoGeneratorOutSpeechWindows(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_speech_windows'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_speech_windows', value)
}

export function writeVideoGeneratorOutVideoPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_video_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_video_prompt', value)
}

export function writeVideoGeneratorOutVideoDuration(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_video_duration'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_video_duration', value)
}

export function writeVideoGeneratorOutDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_dialogue'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_dialogue', value)
}

export function writeVideoGeneratorOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeData['out_video'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'video_generator', 'out_video', value)
}

export function writeWebtoonGroupInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeData['in_scene_id'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_group', 'in_scene_id', value)
}

export function writeWebtoonGroupInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeData['in_label'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_group', 'in_label', value)
}

export function writeWebtoonGroupInCollapsed(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeData['in_collapsed'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_group', 'in_collapsed', value)
}

export function writeWebtoonGroupInChildNodeIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeData['in_child_node_ids'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_group', 'in_child_node_ids', value)
}

export function writeWebtoonPanelGeneratorInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_images'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_images', value)
}

export function writeWebtoonPanelGeneratorInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_prompt'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_prompt', value)
}

export function writeWebtoonPanelGeneratorInBeats(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_beats'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_beats', value)
}

export function writeWebtoonPanelGeneratorInDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_dialogue'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_dialogue', value)
}

export function writeWebtoonPanelGeneratorInPanelIndex(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_panel_index'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_panel_index', value)
}

export function writeWebtoonPanelGeneratorInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_aspect_ratio'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_aspect_ratio', value)
}

export function writeWebtoonPanelGeneratorInLayout(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_layout'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_layout', value)
}

export function writeWebtoonPanelGeneratorInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_style'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_style', value)
}

export function writeWebtoonPanelGeneratorInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_model'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_model', value)
}

export function writeWebtoonPanelGeneratorInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_name'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_name', value)
}

export function writeWebtoonPanelGeneratorInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_feedback'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_feedback', value)
}

export function writeWebtoonPanelGeneratorInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['in_feedback_history'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'in_feedback_history', value)
}

export function writeWebtoonPanelGeneratorOutPanelImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['out_panel_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'out_panel_image', value)
}

export function writeWebtoonPanelGeneratorOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeData['out_image'], undefined>,
): boolean {
  return writeYDocNodeDataField(ynode, 'webtoon_panel_generator', 'out_image', value)
}

// ---------------------------------------------------------------------------
// Generated downstream input flushing
// ---------------------------------------------------------------------------

export type YDocInputFlushEdgeRef = {
  source: string
  sourceHandle?: string
  toIndex?: number
  fromIndex?: number
}

export type YDocInputFlushNode = {
  id: string
  type?: string | null
  data?: object
}

export type YDocInputFlushResult = {
  field: string
  value: YDocWriteValue
  written: boolean
}

type _TypedInputFlushNode<T extends FeNodeType> = {
  id: string
  type: T
  data?: Partial<FeNodeDataMap[T]>
}

type _IndexedInputFlushValue<T> = {
  toIndex?: number
  edgeOrder: number
  valueOrder: number
  value: T
}

function _isInputFlushNodeType<T extends FeNodeType>(
  node: YDocInputFlushNode | undefined,
  type: T,
): node is _TypedInputFlushNode<T> {
  return node?.type === type
}

function _orderedInputFlushEdges(
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushEdgeRef[] {
  return [...edgeRefs].sort((left, right) => {
    if (left.toIndex === undefined && right.toIndex !== undefined) return 1
    if (left.toIndex !== undefined && right.toIndex === undefined) return -1
    if (left.toIndex !== undefined && right.toIndex !== undefined) {
      return left.toIndex - right.toIndex
    }
    return 0
  })
}

function _findInputFlushNode(
  nodes: readonly YDocInputFlushNode[],
  nodeId: string,
): YDocInputFlushNode | undefined {
  return nodes.find((node) => node.id === nodeId)
}

function _missingInputFlushFromIndex(sourcePort: string, targetPort: string): never {
  throw new Error(`${targetPort} requires fromIndex when flushing ${sourcePort}`)
}

function _throwUnsupportedInputFlushEdge(
  sourceType: string | null | undefined,
  sourceHandle: string | undefined,
  targetPort: string,
): never {
  const renderedSource = `${sourceType ?? '<missing>'}.${sourceHandle ?? '<missing>'}`
  throw new Error(`Unsupported generated input flush edge ${renderedSource} -> ${targetPort}`)
}

function _selectIndexedInputFlushValue<T>(
  value: readonly T[] | undefined,
  fromIndex: number | undefined,
  sourcePort: string,
  targetPort: string,
): T | undefined {
  if (fromIndex === undefined) return _missingInputFlushFromIndex(sourcePort, targetPort)
  if (value === undefined) return undefined
  return fromIndex >= 0 && fromIndex < value.length ? value[fromIndex] : undefined
}

function _pushIndexedInputFlushValue<T>(
  values: Array<_IndexedInputFlushValue<T>>,
  edge: YDocInputFlushEdgeRef,
  edgeOrder: number,
  valueOrder: number,
  value: T,
): void {
  values.push({
    toIndex: edge.toIndex === undefined ? undefined : edge.toIndex + valueOrder,
    edgeOrder,
    valueOrder,
    value,
  })
}

function _pushIndexedInputFlushValues<T>(
  values: Array<_IndexedInputFlushValue<T>>,
  edge: YDocInputFlushEdgeRef,
  edgeOrder: number,
  edgeValues: readonly T[],
): void {
  edgeValues.forEach((value, valueOrder) =>
    _pushIndexedInputFlushValue(values, edge, edgeOrder, valueOrder, value),
  )
}

function _orderedInputFlushValues<T>(
  values: Array<_IndexedInputFlushValue<T>>,
): T[] {
  return values
    .sort((left, right) => {
      if (left.toIndex === undefined && right.toIndex !== undefined) return 1
      if (left.toIndex !== undefined && right.toIndex === undefined) return -1
      if (left.toIndex !== undefined && right.toIndex !== undefined) {
        if (left.toIndex !== right.toIndex) return left.toIndex - right.toIndex
      }
      if (left.edgeOrder !== right.edgeOrder) return left.edgeOrder - right.edgeOrder
      return left.valueOrder - right.valueOrder
    })
    .map((item) => item.value)
}

export function flushYDocInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetNode: YDocInputFlushNode,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetNode.type) {
    case 'audio':
      return _flushAudioInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'brandFilm':
      return _flushBrandFilmInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'captioner':
      return _flushCaptionerInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'characterDesigner':
      return _flushCharacterDesignerInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'debugHang':
      return _flushDebugHangInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'director':
      return _flushDirectorInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'directorStage':
      return _flushDirectorStageInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'generatedImageWithHistory':
      return _flushGeneratedImageWithHistoryInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'hyperframeRenderer':
      return _flushHyperframeRendererInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'image':
      return _flushImageInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'imageGenerator':
      return _flushImageGeneratorInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'locationDesigner':
      return _flushLocationDesignerInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'nodeGroup':
      return _flushNodeGroupInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'objectDesigner':
      return _flushObjectDesignerInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'panelSource':
      return _flushPanelSourceInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'promptInput':
      return _flushPromptInputInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'remotionComposer':
      return _flushRemotionComposerInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'screenplayWriter':
      return _flushScreenplayWriterInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'scriptWriter':
      return _flushScriptWriterInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'shortVideoGroup':
      return _flushShortVideoGroupInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'singingPortrait':
      return _flushSingingPortraitInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'soundExpert':
      return _flushSoundExpertInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'speechGenerator':
      return _flushSpeechGeneratorInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'storyDirectionPreview':
      return _flushStoryDirectionPreviewInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'storyboardDesigner':
      return _flushStoryboardDesignerInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'storyboardNoEnhanceDesigner':
      return _flushStoryboardNoEnhanceDesignerInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'text':
      return _flushTextInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'video':
      return _flushVideoInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'videoEditor':
      return _flushVideoEditorInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'videoGenerator':
      return _flushVideoGeneratorInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'webtoonGroup':
      return _flushWebtoonGroupInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    case 'webtoonPanelGenerator':
      return _flushWebtoonPanelGeneratorInputFromEdgeRefs(ynode, targetHandle, nodes, edgeRefs)
    default:
      return undefined
  }
}

function _flushAudioInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_file_name': {
      const value = _resolveAudioInFileNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeAudioInFileName(ynode, value)
      return { field: 'in_file_name', value, written }
    }
    default:
      return undefined
  }
}

function _resolveAudioInFileNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): AudioNodeData['in_file_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'audio.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'audio.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'audio.in_file_name')
  }
  return undefined
}

function _flushBrandFilmInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_plan': {
      const value = _resolveBrandFilmInPlanInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeBrandFilmInPlan(ynode, value)
      return { field: 'in_plan', value, written }
    }
    case 'in_clips': {
      const value = _resolveBrandFilmInClipsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeBrandFilmInClips(ynode, value)
      return { field: 'in_clips', value, written }
    }
    case 'in_voiceover': {
      const value = _resolveBrandFilmInVoiceoverInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeBrandFilmInVoiceover(ynode, value)
      return { field: 'in_voiceover', value, written }
    }
    case 'in_music': {
      const value = _resolveBrandFilmInMusicInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeBrandFilmInMusic(ynode, value)
      return { field: 'in_music', value, written }
    }
    case 'in_name': {
      const value = _resolveBrandFilmInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeBrandFilmInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    default:
      return undefined
  }
}

function _resolveBrandFilmInPlanInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): BrandFilmNodeData['in_plan'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'brandFilm.in_plan')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'brandFilm.in_plan')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'brandFilm.in_plan')
  }
  return undefined
}

function _resolveBrandFilmInClipsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): BrandFilmNodeData['in_clips'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<BrandFilmNodeData['in_clips']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'brandFilm.in_clips')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'brandFilm.in_clips')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'brandFilm.in_clips')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'brandFilm.in_clips')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveBrandFilmInVoiceoverInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): BrandFilmNodeData['in_voiceover'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<BrandFilmNodeData['in_voiceover']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'brandFilm.in_voiceover')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'brandFilm.in_voiceover')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'brandFilm.in_voiceover')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'brandFilm.in_voiceover')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveBrandFilmInMusicInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): BrandFilmNodeData['in_music'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'brandFilm.in_music')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'brandFilm.in_music')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'brandFilm.in_music')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'brandFilm.in_music')
  }
  return undefined
}

function _resolveBrandFilmInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): BrandFilmNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'brandFilm.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'brandFilm.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'brandFilm.in_name')
  }
  return undefined
}

function _flushCaptionerInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_video': {
      const value = _resolveCaptionerInVideoInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCaptionerInVideo(ynode, value)
      return { field: 'in_video', value, written }
    }
    case 'in_language': {
      const value = _resolveCaptionerInLanguageInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCaptionerInLanguage(ynode, value)
      return { field: 'in_language', value, written }
    }
    case 'in_caption_style': {
      const value = _resolveCaptionerInCaptionStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCaptionerInCaptionStyle(ynode, value)
      return { field: 'in_caption_style', value, written }
    }
    case 'in_name': {
      const value = _resolveCaptionerInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCaptionerInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_feedback': {
      const value = _resolveCaptionerInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCaptionerInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    default:
      return undefined
  }
}

function _resolveCaptionerInVideoInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CaptionerNodeData['in_video'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'captioner.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'captioner.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'captioner.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'captioner.in_video')
  }
  return undefined
}

function _resolveCaptionerInLanguageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CaptionerNodeData['in_language'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'captioner.in_language')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'captioner.in_language')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'captioner.in_language')
  }
  return undefined
}

function _resolveCaptionerInCaptionStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CaptionerNodeData['in_caption_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'captioner.in_caption_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'captioner.in_caption_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'captioner.in_caption_style')
  }
  return undefined
}

function _resolveCaptionerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CaptionerNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'captioner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'captioner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'captioner.in_name')
  }
  return undefined
}

function _resolveCaptionerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CaptionerNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'captioner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'captioner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'captioner.in_feedback')
  }
  return undefined
}

function _flushCharacterDesignerInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_upstream': {
      const value = _resolveCharacterDesignerInUpstreamInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInUpstream(ynode, value)
      return { field: 'in_upstream', value, written }
    }
    case 'in_images': {
      const value = _resolveCharacterDesignerInImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInImages(ynode, value)
      return { field: 'in_images', value, written }
    }
    case 'in_ref_images': {
      const value = _resolveCharacterDesignerInRefImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInRefImages(ynode, value)
      return { field: 'in_ref_images', value, written }
    }
    case 'in_name': {
      const value = _resolveCharacterDesignerInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_role': {
      const value = _resolveCharacterDesignerInRoleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInRole(ynode, value)
      return { field: 'in_role', value, written }
    }
    case 'in_style': {
      const value = _resolveCharacterDesignerInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_description': {
      const value = _resolveCharacterDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInDescription(ynode, value)
      return { field: 'in_description', value, written }
    }
    case 'in_model': {
      const value = _resolveCharacterDesignerInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_feedback': {
      const value = _resolveCharacterDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveCharacterDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    case 'in_pronunciation_guide': {
      const value = _resolveCharacterDesignerInPronunciationGuideInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInPronunciationGuide(ynode, value)
      return { field: 'in_pronunciation_guide', value, written }
    }
    case 'in_bg_color': {
      const value = _resolveCharacterDesignerInBgColorInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInBgColor(ynode, value)
      return { field: 'in_bg_color', value, written }
    }
    case 'in_voice_descriptor': {
      const value = _resolveCharacterDesignerInVoiceDescriptorInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeCharacterDesignerInVoiceDescriptor(ynode, value)
      return { field: 'in_voice_descriptor', value, written }
    }
    default:
      return undefined
  }
}

function _resolveCharacterDesignerInUpstreamInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_upstream'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_upstream')
  }
  return undefined
}

function _resolveCharacterDesignerInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_images'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<CharacterDesignerNodeData['in_images']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveCharacterDesignerInRefImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_ref_images'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'screenplayWriter') && edge.sourceHandle === 'out_music_prompts') {
      const value = sourceNode.data?.out_music_prompts
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'characterDesigner.in_ref_images')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_ref_images')
  }
  return undefined
}

function _resolveCharacterDesignerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_name')
  }
  return undefined
}

function _resolveCharacterDesignerInRoleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_role'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_role')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_role')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_role')
  }
  return undefined
}

function _resolveCharacterDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_style')
  }
  return undefined
}

function _resolveCharacterDesignerInDescriptionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_description'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_description')
  }
  return undefined
}

function _resolveCharacterDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_model')
  }
  return undefined
}

function _resolveCharacterDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_feedback')
  }
  return undefined
}

function _resolveCharacterDesignerInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_feedback_history')
  }
  return undefined
}

function _resolveCharacterDesignerInPronunciationGuideInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_pronunciation_guide'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_pronunciation_guide')
  }
  return undefined
}

function _resolveCharacterDesignerInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_bg_color'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_bg_color')
  }
  return undefined
}

function _resolveCharacterDesignerInVoiceDescriptorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): CharacterDesignerNodeData['in_voice_descriptor'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_voice_descriptor')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_voice_descriptor')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_voice_descriptor')
  }
  return undefined
}

function _flushDebugHangInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_label': {
      const value = _resolveDebugHangInLabelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeDebugHangInLabel(ynode, value)
      return { field: 'in_label', value, written }
    }
    default:
      return undefined
  }
}

function _resolveDebugHangInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): DebugHangNodeData['in_label'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'debugHang.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'debugHang.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'debugHang.in_label')
  }
  return undefined
}

function _flushDirectorInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_context': {
      const value = _resolveDirectorInContextInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeDirectorInContext(ynode, value)
      return { field: 'in_context', value, written }
    }
    default:
      return undefined
  }
}

function _resolveDirectorInContextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): DirectorNodeData['in_context'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'director.in_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'director.in_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'director.in_context')
  }
  return undefined
}

function _flushDirectorStageInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_name': {
      const value = _resolveDirectorStageInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeDirectorStageInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_scene': {
      const value = _resolveDirectorStageInSceneInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeDirectorStageInScene(ynode, value)
      return { field: 'in_scene', value, written }
    }
    default:
      return undefined
  }
}

function _resolveDirectorStageInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): DirectorStageNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'directorStage.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'directorStage.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'directorStage.in_name')
  }
  return undefined
}

function _resolveDirectorStageInSceneInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): DirectorStageNodeData['in_scene'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'directorStage.in_scene')
  }
  return undefined
}

function _flushGeneratedImageWithHistoryInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    default:
      return undefined
  }
  void ynode
  void nodes
  void edgeRefs
}

function _flushHyperframeRendererInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_template_html': {
      const value = _resolveHyperframeRendererInTemplateHtmlInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInTemplateHtml(ynode, value)
      return { field: 'in_template_html', value, written }
    }
    case 'in_props_json': {
      const value = _resolveHyperframeRendererInPropsJsonInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInPropsJson(ynode, value)
      return { field: 'in_props_json', value, written }
    }
    case 'in_media': {
      const value = _resolveHyperframeRendererInMediaInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInMedia(ynode, value)
      return { field: 'in_media', value, written }
    }
    case 'in_duration_seconds': {
      const value = _resolveHyperframeRendererInDurationSecondsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInDurationSeconds(ynode, value)
      return { field: 'in_duration_seconds', value, written }
    }
    case 'in_aspect_ratio': {
      const value = _resolveHyperframeRendererInAspectRatioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInAspectRatio(ynode, value)
      return { field: 'in_aspect_ratio', value, written }
    }
    case 'in_resolution': {
      const value = _resolveHyperframeRendererInResolutionInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInResolution(ynode, value)
      return { field: 'in_resolution', value, written }
    }
    case 'in_fps': {
      const value = _resolveHyperframeRendererInFpsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInFps(ynode, value)
      return { field: 'in_fps', value, written }
    }
    case 'in_strict_lint': {
      const value = _resolveHyperframeRendererInStrictLintInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInStrictLint(ynode, value)
      return { field: 'in_strict_lint', value, written }
    }
    case 'in_name': {
      const value = _resolveHyperframeRendererInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeHyperframeRendererInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    default:
      return undefined
  }
}

function _resolveHyperframeRendererInTemplateHtmlInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_template_html'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'hyperframeRenderer.in_template_html')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'hyperframeRenderer.in_template_html')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_template_html')
  }
  return undefined
}

function _resolveHyperframeRendererInPropsJsonInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_props_json'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'hyperframeRenderer.in_props_json')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'hyperframeRenderer.in_props_json')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_props_json')
  }
  return undefined
}

function _resolveHyperframeRendererInMediaInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_media'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<HyperframeRendererNodeData['in_media']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'hyperframeRenderer.in_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'hyperframeRenderer.in_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'hyperframeRenderer.in_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_media')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveHyperframeRendererInDurationSecondsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_duration_seconds'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_duration_seconds')
  }
  return undefined
}

function _resolveHyperframeRendererInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_aspect_ratio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'hyperframeRenderer.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'hyperframeRenderer.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_aspect_ratio')
  }
  return undefined
}

function _resolveHyperframeRendererInResolutionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_resolution'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'hyperframeRenderer.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'hyperframeRenderer.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_resolution')
  }
  return undefined
}

function _resolveHyperframeRendererInFpsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_fps'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_fps')
  }
  return undefined
}

function _resolveHyperframeRendererInStrictLintInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_strict_lint'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_strict_lint')
  }
  return undefined
}

function _resolveHyperframeRendererInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): HyperframeRendererNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'hyperframeRenderer.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'hyperframeRenderer.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'hyperframeRenderer.in_name')
  }
  return undefined
}

function _flushImageInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_file_name': {
      const value = _resolveImageInFileNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageInFileName(ynode, value)
      return { field: 'in_file_name', value, written }
    }
    case 'in_source': {
      const value = _resolveImageInSourceInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageInSource(ynode, value)
      return { field: 'in_source', value, written }
    }
    default:
      return undefined
  }
}

function _resolveImageInFileNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageNodeData['in_file_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'image.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'image.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'image.in_file_name')
  }
  return undefined
}

function _resolveImageInSourceInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageNodeData['in_source'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'image.in_source')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'image.in_source')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'image.in_source')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'image.in_source')
  }
  return undefined
}

function _flushImageGeneratorInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_images': {
      const value = _resolveImageGeneratorInImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInImages(ynode, value)
      return { field: 'in_images', value, written }
    }
    case 'in_ref_images': {
      const value = _resolveImageGeneratorInRefImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInRefImages(ynode, value)
      return { field: 'in_ref_images', value, written }
    }
    case 'in_upstream': {
      const value = _resolveImageGeneratorInUpstreamInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInUpstream(ynode, value)
      return { field: 'in_upstream', value, written }
    }
    case 'in_storyboard_meta': {
      const value = _resolveImageGeneratorInStoryboardMetaInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInStoryboardMeta(ynode, value)
      return { field: 'in_storyboard_meta', value, written }
    }
    case 'in_name': {
      const value = _resolveImageGeneratorInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_prompt': {
      const value = _resolveImageGeneratorInPromptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInPrompt(ynode, value)
      return { field: 'in_prompt', value, written }
    }
    case 'in_aspect_ratio': {
      const value = _resolveImageGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInAspectRatio(ynode, value)
      return { field: 'in_aspect_ratio', value, written }
    }
    case 'in_style': {
      const value = _resolveImageGeneratorInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_quality': {
      const value = _resolveImageGeneratorInQualityInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInQuality(ynode, value)
      return { field: 'in_quality', value, written }
    }
    case 'in_model': {
      const value = _resolveImageGeneratorInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_panel_refs': {
      const value = _resolveImageGeneratorInPanelRefsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInPanelRefs(ynode, value)
      return { field: 'in_panel_refs', value, written }
    }
    case 'in_update': {
      const value = _resolveImageGeneratorInUpdateInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInUpdate(ynode, value)
      return { field: 'in_update', value, written }
    }
    case 'in_image': {
      const value = _resolveImageGeneratorInImageInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInImage(ynode, value)
      return { field: 'in_image', value, written }
    }
    case 'in_feedback': {
      const value = _resolveImageGeneratorInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_video': {
      const value = _resolveImageGeneratorInVideoInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInVideo(ynode, value)
      return { field: 'in_video', value, written }
    }
    case 'in_frame': {
      const value = _resolveImageGeneratorInFrameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInFrame(ynode, value)
      return { field: 'in_frame', value, written }
    }
    case 'in_get_frame': {
      const value = _resolveImageGeneratorInGetFrameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInGetFrame(ynode, value)
      return { field: 'in_get_frame', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveImageGeneratorInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeImageGeneratorInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    default:
      return undefined
  }
}

function _resolveImageGeneratorInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_images'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<ImageGeneratorNodeData['in_images']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveImageGeneratorInRefImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_ref_images'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'screenplayWriter') && edge.sourceHandle === 'out_music_prompts') {
      const value = sourceNode.data?.out_music_prompts
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'imageGenerator.in_ref_images')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_ref_images')
  }
  return undefined
}

function _resolveImageGeneratorInUpstreamInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_upstream'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_upstream')
  }
  return undefined
}

function _resolveImageGeneratorInStoryboardMetaInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_storyboard_meta'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_storyboard_meta')
  }
  return undefined
}

function _resolveImageGeneratorInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_name')
  }
  return undefined
}

function _resolveImageGeneratorInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_prompt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_prompt')
  }
  return undefined
}

function _resolveImageGeneratorInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_aspect_ratio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_aspect_ratio')
  }
  return undefined
}

function _resolveImageGeneratorInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_style')
  }
  return undefined
}

function _resolveImageGeneratorInQualityInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_quality'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_quality')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_quality')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_quality')
  }
  return undefined
}

function _resolveImageGeneratorInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_model')
  }
  return undefined
}

function _resolveImageGeneratorInPanelRefsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_panel_refs'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'screenplayWriter') && edge.sourceHandle === 'out_music_prompts') {
      const value = sourceNode.data?.out_music_prompts
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'imageGenerator.in_panel_refs')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_panel_refs')
  }
  return undefined
}

function _resolveImageGeneratorInUpdateInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_update'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_update')
  }
  return undefined
}

function _resolveImageGeneratorInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_image'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_image')
  }
  return undefined
}

function _resolveImageGeneratorInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_feedback')
  }
  return undefined
}

function _resolveImageGeneratorInVideoInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_video'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_video')
  }
  return undefined
}

function _resolveImageGeneratorInFrameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_frame'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_frame')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_frame')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_frame')
  }
  return undefined
}

function _resolveImageGeneratorInGetFrameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_get_frame'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_get_frame')
  }
  return undefined
}

function _resolveImageGeneratorInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ImageGeneratorNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_feedback_history')
  }
  return undefined
}

function _flushLocationDesignerInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_images': {
      const value = _resolveLocationDesignerInImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInImages(ynode, value)
      return { field: 'in_images', value, written }
    }
    case 'in_ref_images': {
      const value = _resolveLocationDesignerInRefImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInRefImages(ynode, value)
      return { field: 'in_ref_images', value, written }
    }
    case 'in_name': {
      const value = _resolveLocationDesignerInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_style': {
      const value = _resolveLocationDesignerInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_time_of_day': {
      const value = _resolveLocationDesignerInTimeOfDayInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInTimeOfDay(ynode, value)
      return { field: 'in_time_of_day', value, written }
    }
    case 'in_weather': {
      const value = _resolveLocationDesignerInWeatherInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInWeather(ynode, value)
      return { field: 'in_weather', value, written }
    }
    case 'in_description': {
      const value = _resolveLocationDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInDescription(ynode, value)
      return { field: 'in_description', value, written }
    }
    case 'in_model': {
      const value = _resolveLocationDesignerInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_feedback': {
      const value = _resolveLocationDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveLocationDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    case 'in_bg_color': {
      const value = _resolveLocationDesignerInBgColorInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeLocationDesignerInBgColor(ynode, value)
      return { field: 'in_bg_color', value, written }
    }
    default:
      return undefined
  }
}

function _resolveLocationDesignerInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_images'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<LocationDesignerNodeData['in_images']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveLocationDesignerInRefImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_ref_images'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'screenplayWriter') && edge.sourceHandle === 'out_music_prompts') {
      const value = sourceNode.data?.out_music_prompts
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'locationDesigner.in_ref_images')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_ref_images')
  }
  return undefined
}

function _resolveLocationDesignerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_name')
  }
  return undefined
}

function _resolveLocationDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_style')
  }
  return undefined
}

function _resolveLocationDesignerInTimeOfDayInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_time_of_day'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_time_of_day')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_time_of_day')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_time_of_day')
  }
  return undefined
}

function _resolveLocationDesignerInWeatherInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_weather'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_weather')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_weather')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_weather')
  }
  return undefined
}

function _resolveLocationDesignerInDescriptionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_description'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_description')
  }
  return undefined
}

function _resolveLocationDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_model')
  }
  return undefined
}

function _resolveLocationDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_feedback')
  }
  return undefined
}

function _resolveLocationDesignerInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_feedback_history')
  }
  return undefined
}

function _resolveLocationDesignerInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): LocationDesignerNodeData['in_bg_color'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_bg_color')
  }
  return undefined
}

function _flushNodeGroupInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_label': {
      const value = _resolveNodeGroupInLabelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeNodeGroupInLabel(ynode, value)
      return { field: 'in_label', value, written }
    }
    case 'in_child_node_ids': {
      const value = _resolveNodeGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeNodeGroupInChildNodeIds(ynode, value)
      return { field: 'in_child_node_ids', value, written }
    }
    case 'in_layout_mode': {
      const value = _resolveNodeGroupInLayoutModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeNodeGroupInLayoutMode(ynode, value)
      return { field: 'in_layout_mode', value, written }
    }
    case 'in_bg_color': {
      const value = _resolveNodeGroupInBgColorInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeNodeGroupInBgColor(ynode, value)
      return { field: 'in_bg_color', value, written }
    }
    default:
      return undefined
  }
}

function _resolveNodeGroupInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): NodeGroupNodeData['in_label'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'nodeGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'nodeGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_label')
  }
  return undefined
}

function _resolveNodeGroupInChildNodeIdsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): NodeGroupNodeData['in_child_node_ids'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_child_node_ids')
  }
  return undefined
}

function _resolveNodeGroupInLayoutModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): NodeGroupNodeData['in_layout_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'nodeGroup.in_layout_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'nodeGroup.in_layout_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_layout_mode')
  }
  return undefined
}

function _resolveNodeGroupInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): NodeGroupNodeData['in_bg_color'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'nodeGroup.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'nodeGroup.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_bg_color')
  }
  return undefined
}

function _flushObjectDesignerInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_images': {
      const value = _resolveObjectDesignerInImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInImages(ynode, value)
      return { field: 'in_images', value, written }
    }
    case 'in_ref_images': {
      const value = _resolveObjectDesignerInRefImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInRefImages(ynode, value)
      return { field: 'in_ref_images', value, written }
    }
    case 'in_name': {
      const value = _resolveObjectDesignerInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_style': {
      const value = _resolveObjectDesignerInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_description': {
      const value = _resolveObjectDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInDescription(ynode, value)
      return { field: 'in_description', value, written }
    }
    case 'in_model': {
      const value = _resolveObjectDesignerInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_feedback': {
      const value = _resolveObjectDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveObjectDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeObjectDesignerInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    default:
      return undefined
  }
}

function _resolveObjectDesignerInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_images'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<ObjectDesignerNodeData['in_images']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveObjectDesignerInRefImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_ref_images'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'screenplayWriter') && edge.sourceHandle === 'out_music_prompts') {
      const value = sourceNode.data?.out_music_prompts
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'objectDesigner.in_ref_images')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_ref_images')
  }
  return undefined
}

function _resolveObjectDesignerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_name')
  }
  return undefined
}

function _resolveObjectDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_style')
  }
  return undefined
}

function _resolveObjectDesignerInDescriptionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_description'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_description')
  }
  return undefined
}

function _resolveObjectDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_model')
  }
  return undefined
}

function _resolveObjectDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_feedback')
  }
  return undefined
}

function _resolveObjectDesignerInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ObjectDesignerNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_feedback_history')
  }
  return undefined
}

function _flushPanelSourceInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    default:
      return undefined
  }
  void ynode
  void nodes
  void edgeRefs
}

function _flushPromptInputInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    default:
      return undefined
  }
  void ynode
  void nodes
  void edgeRefs
}

function _flushRemotionComposerInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_clip': {
      const value = _resolveRemotionComposerInClipInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInClip(ynode, value)
      return { field: 'in_clip', value, written }
    }
    case 'in_clips': {
      const value = _resolveRemotionComposerInClipsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInClips(ynode, value)
      return { field: 'in_clips', value, written }
    }
    case 'in_audio': {
      const value = _resolveRemotionComposerInAudioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInAudio(ynode, value)
      return { field: 'in_audio', value, written }
    }
    case 'in_brand_name': {
      const value = _resolveRemotionComposerInBrandNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInBrandName(ynode, value)
      return { field: 'in_brand_name', value, written }
    }
    case 'in_tagline': {
      const value = _resolveRemotionComposerInTaglineInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInTagline(ynode, value)
      return { field: 'in_tagline', value, written }
    }
    case 'in_captions': {
      const value = _resolveRemotionComposerInCaptionsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInCaptions(ynode, value)
      return { field: 'in_captions', value, written }
    }
    case 'in_composition_id': {
      const value = _resolveRemotionComposerInCompositionIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInCompositionId(ynode, value)
      return { field: 'in_composition_id', value, written }
    }
    case 'in_aspect': {
      const value = _resolveRemotionComposerInAspectInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInAspect(ynode, value)
      return { field: 'in_aspect', value, written }
    }
    case 'in_clip_duration_seconds': {
      const value = _resolveRemotionComposerInClipDurationSecondsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInClipDurationSeconds(ynode, value)
      return { field: 'in_clip_duration_seconds', value, written }
    }
    case 'in_name': {
      const value = _resolveRemotionComposerInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeRemotionComposerInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    default:
      return undefined
  }
}

function _resolveRemotionComposerInClipInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_clip'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'remotionComposer.in_clip')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'remotionComposer.in_clip')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'remotionComposer.in_clip')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_clip')
  }
  return undefined
}

function _resolveRemotionComposerInClipsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_clips'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<RemotionComposerNodeData['in_clips']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'remotionComposer.in_clips')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'remotionComposer.in_clips')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'remotionComposer.in_clips')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_clips')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveRemotionComposerInAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_audio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'remotionComposer.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'remotionComposer.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'remotionComposer.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_audio')
  }
  return undefined
}

function _resolveRemotionComposerInBrandNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_brand_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'remotionComposer.in_brand_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'remotionComposer.in_brand_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_brand_name')
  }
  return undefined
}

function _resolveRemotionComposerInTaglineInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_tagline'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'remotionComposer.in_tagline')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'remotionComposer.in_tagline')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_tagline')
  }
  return undefined
}

function _resolveRemotionComposerInCaptionsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_captions'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_captions')
  }
  return undefined
}

function _resolveRemotionComposerInCompositionIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_composition_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'remotionComposer.in_composition_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'remotionComposer.in_composition_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_composition_id')
  }
  return undefined
}

function _resolveRemotionComposerInAspectInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_aspect'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'remotionComposer.in_aspect')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'remotionComposer.in_aspect')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_aspect')
  }
  return undefined
}

function _resolveRemotionComposerInClipDurationSecondsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_clip_duration_seconds'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_clip_duration_seconds')
  }
  return undefined
}

function _resolveRemotionComposerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): RemotionComposerNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'remotionComposer.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'remotionComposer.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'remotionComposer.in_name')
  }
  return undefined
}

function _flushScreenplayWriterInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_story_context': {
      const value = _resolveScreenplayWriterInStoryContextInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScreenplayWriterInStoryContext(ynode, value)
      return { field: 'in_story_context', value, written }
    }
    case 'in_characters': {
      const value = _resolveScreenplayWriterInCharactersInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScreenplayWriterInCharacters(ynode, value)
      return { field: 'in_characters', value, written }
    }
    case 'in_locations': {
      const value = _resolveScreenplayWriterInLocationsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScreenplayWriterInLocations(ynode, value)
      return { field: 'in_locations', value, written }
    }
    case 'in_user_script': {
      const value = _resolveScreenplayWriterInUserScriptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScreenplayWriterInUserScript(ynode, value)
      return { field: 'in_user_script', value, written }
    }
    case 'in_style': {
      const value = _resolveScreenplayWriterInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScreenplayWriterInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    default:
      return undefined
  }
}

function _resolveScreenplayWriterInStoryContextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScreenplayWriterNodeData['in_story_context'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'screenplayWriter.in_story_context')
  }
  return undefined
}

function _resolveScreenplayWriterInCharactersInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScreenplayWriterNodeData['in_characters'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<ScreenplayWriterNodeData['in_characters']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'screenplayWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'screenplayWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'screenplayWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'screenplayWriter.in_characters')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveScreenplayWriterInLocationsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScreenplayWriterNodeData['in_locations'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<ScreenplayWriterNodeData['in_locations']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'screenplayWriter.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'screenplayWriter.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'screenplayWriter.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'screenplayWriter.in_locations')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveScreenplayWriterInUserScriptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScreenplayWriterNodeData['in_user_script'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'screenplayWriter.in_user_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'screenplayWriter.in_user_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'screenplayWriter.in_user_script')
  }
  return undefined
}

function _resolveScreenplayWriterInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScreenplayWriterNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'screenplayWriter.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'screenplayWriter.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'screenplayWriter.in_style')
  }
  return undefined
}

function _flushScriptWriterInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_prompt': {
      const value = _resolveScriptWriterInPromptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInPrompt(ynode, value)
      return { field: 'in_prompt', value, written }
    }
    case 'in_style': {
      const value = _resolveScriptWriterInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_active_model': {
      const value = _resolveScriptWriterInActiveModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInActiveModel(ynode, value)
      return { field: 'in_active_model', value, written }
    }
    case 'in_name': {
      const value = _resolveScriptWriterInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_director_instruction': {
      const value = _resolveScriptWriterInDirectorInstructionInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInDirectorInstruction(ynode, value)
      return { field: 'in_director_instruction', value, written }
    }
    case 'in_format_only': {
      const value = _resolveScriptWriterInFormatOnlyInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInFormatOnly(ynode, value)
      return { field: 'in_format_only', value, written }
    }
    case 'in_gemini': {
      const value = _resolveScriptWriterInGeminiInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInGemini(ynode, value)
      return { field: 'in_gemini', value, written }
    }
    case 'in_claude': {
      const value = _resolveScriptWriterInClaudeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInClaude(ynode, value)
      return { field: 'in_claude', value, written }
    }
    case 'in_gpt': {
      const value = _resolveScriptWriterInGptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInGpt(ynode, value)
      return { field: 'in_gpt', value, written }
    }
    case 'in_characters': {
      const value = _resolveScriptWriterInCharactersInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInCharacters(ynode, value)
      return { field: 'in_characters', value, written }
    }
    case 'in_feedback': {
      const value = _resolveScriptWriterInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_target_duration_s': {
      const value = _resolveScriptWriterInTargetDurationSInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInTargetDurationS(ynode, value)
      return { field: 'in_target_duration_s', value, written }
    }
    case 'in_ending': {
      const value = _resolveScriptWriterInEndingInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInEnding(ynode, value)
      return { field: 'in_ending', value, written }
    }
    case 'in_review_history': {
      const value = _resolveScriptWriterInReviewHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInReviewHistory(ynode, value)
      return { field: 'in_review_history', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveScriptWriterInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    case 'in_bg_color': {
      const value = _resolveScriptWriterInBgColorInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeScriptWriterInBgColor(ynode, value)
      return { field: 'in_bg_color', value, written }
    }
    default:
      return undefined
  }
}

function _resolveScriptWriterInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_prompt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_prompt')
  }
  return undefined
}

function _resolveScriptWriterInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_style')
  }
  return undefined
}

function _resolveScriptWriterInActiveModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_active_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_active_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_active_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_active_model')
  }
  return undefined
}

function _resolveScriptWriterInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_name')
  }
  return undefined
}

function _resolveScriptWriterInDirectorInstructionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_director_instruction'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_director_instruction')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_director_instruction')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_director_instruction')
  }
  return undefined
}

function _resolveScriptWriterInFormatOnlyInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_format_only'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_format_only')
  }
  return undefined
}

function _resolveScriptWriterInGeminiInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_gemini'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_gemini')
  }
  return undefined
}

function _resolveScriptWriterInClaudeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_claude'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_claude')
  }
  return undefined
}

function _resolveScriptWriterInGptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_gpt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_gpt')
  }
  return undefined
}

function _resolveScriptWriterInCharactersInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_characters'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<ScriptWriterNodeData['in_characters']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_characters')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveScriptWriterInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_feedback')
  }
  return undefined
}

function _resolveScriptWriterInTargetDurationSInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_target_duration_s'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_target_duration_s')
  }
  return undefined
}

function _resolveScriptWriterInEndingInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_ending'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_ending')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_ending')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_ending')
  }
  return undefined
}

function _resolveScriptWriterInReviewHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_review_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_review_history')
  }
  return undefined
}

function _resolveScriptWriterInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_feedback_history')
  }
  return undefined
}

function _resolveScriptWriterInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ScriptWriterNodeData['in_bg_color'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_bg_color')
  }
  return undefined
}

function _flushShortVideoGroupInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_label': {
      const value = _resolveShortVideoGroupInLabelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeShortVideoGroupInLabel(ynode, value)
      return { field: 'in_label', value, written }
    }
    case 'in_collapsed': {
      const value = _resolveShortVideoGroupInCollapsedInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeShortVideoGroupInCollapsed(ynode, value)
      return { field: 'in_collapsed', value, written }
    }
    case 'in_storyboard_path': {
      const value = _resolveShortVideoGroupInStoryboardPathInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeShortVideoGroupInStoryboardPath(ynode, value)
      return { field: 'in_storyboard_path', value, written }
    }
    case 'in_image': {
      const value = _resolveShortVideoGroupInImageInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeShortVideoGroupInImage(ynode, value)
      return { field: 'in_image', value, written }
    }
    case 'in_child_node_ids': {
      const value = _resolveShortVideoGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeShortVideoGroupInChildNodeIds(ynode, value)
      return { field: 'in_child_node_ids', value, written }
    }
    default:
      return undefined
  }
}

function _resolveShortVideoGroupInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ShortVideoGroupNodeData['in_label'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'shortVideoGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'shortVideoGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_label')
  }
  return undefined
}

function _resolveShortVideoGroupInCollapsedInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ShortVideoGroupNodeData['in_collapsed'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_collapsed')
  }
  return undefined
}

function _resolveShortVideoGroupInStoryboardPathInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ShortVideoGroupNodeData['in_storyboard_path'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'shortVideoGroup.in_storyboard_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'shortVideoGroup.in_storyboard_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_storyboard_path')
  }
  return undefined
}

function _resolveShortVideoGroupInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ShortVideoGroupNodeData['in_image'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_image')
  }
  return undefined
}

function _resolveShortVideoGroupInChildNodeIdsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): ShortVideoGroupNodeData['in_child_node_ids'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'screenplayWriter') && edge.sourceHandle === 'out_music_prompts') {
      const value = sourceNode.data?.out_music_prompts
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'shortVideoGroup.in_child_node_ids')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_child_node_ids')
  }
  return undefined
}

function _flushSingingPortraitInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_image': {
      const value = _resolveSingingPortraitInImageInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInImage(ynode, value)
      return { field: 'in_image', value, written }
    }
    case 'in_audio': {
      const value = _resolveSingingPortraitInAudioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInAudio(ynode, value)
      return { field: 'in_audio', value, written }
    }
    case 'in_audio_start_s': {
      const value = _resolveSingingPortraitInAudioStartSInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInAudioStartS(ynode, value)
      return { field: 'in_audio_start_s', value, written }
    }
    case 'in_lyrics': {
      const value = _resolveSingingPortraitInLyricsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInLyrics(ynode, value)
      return { field: 'in_lyrics', value, written }
    }
    case 'in_song_style': {
      const value = _resolveSingingPortraitInSongStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInSongStyle(ynode, value)
      return { field: 'in_song_style', value, written }
    }
    case 'in_motion': {
      const value = _resolveSingingPortraitInMotionInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInMotion(ynode, value)
      return { field: 'in_motion', value, written }
    }
    case 'in_scenes': {
      const value = _resolveSingingPortraitInScenesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInScenes(ynode, value)
      return { field: 'in_scenes', value, written }
    }
    case 'in_prompt': {
      const value = _resolveSingingPortraitInPromptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInPrompt(ynode, value)
      return { field: 'in_prompt', value, written }
    }
    case 'in_duration': {
      const value = _resolveSingingPortraitInDurationInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInDuration(ynode, value)
      return { field: 'in_duration', value, written }
    }
    case 'in_aspect_ratio': {
      const value = _resolveSingingPortraitInAspectRatioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInAspectRatio(ynode, value)
      return { field: 'in_aspect_ratio', value, written }
    }
    case 'in_name': {
      const value = _resolveSingingPortraitInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_feedback': {
      const value = _resolveSingingPortraitInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSingingPortraitInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    default:
      return undefined
  }
}

function _resolveSingingPortraitInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_image'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'singingPortrait.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'singingPortrait.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'singingPortrait.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_image')
  }
  return undefined
}

function _resolveSingingPortraitInAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_audio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'singingPortrait.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'singingPortrait.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'singingPortrait.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_audio')
  }
  return undefined
}

function _resolveSingingPortraitInAudioStartSInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_audio_start_s'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_audio_start_s')
  }
  return undefined
}

function _resolveSingingPortraitInLyricsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_lyrics'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_lyrics')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_lyrics')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_lyrics')
  }
  return undefined
}

function _resolveSingingPortraitInSongStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_song_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_song_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_song_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_song_style')
  }
  return undefined
}

function _resolveSingingPortraitInMotionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_motion'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_motion')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_motion')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_motion')
  }
  return undefined
}

function _resolveSingingPortraitInScenesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_scenes'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<SingingPortraitNodeData['in_scenes']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_scenes')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_scenes')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_scenes')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveSingingPortraitInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_prompt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_prompt')
  }
  return undefined
}

function _resolveSingingPortraitInDurationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_duration'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_duration')
  }
  return undefined
}

function _resolveSingingPortraitInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_aspect_ratio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_aspect_ratio')
  }
  return undefined
}

function _resolveSingingPortraitInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_name')
  }
  return undefined
}

function _resolveSingingPortraitInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SingingPortraitNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'singingPortrait.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'singingPortrait.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'singingPortrait.in_feedback')
  }
  return undefined
}

function _flushSoundExpertInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_name': {
      const value = _resolveSoundExpertInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_upstream': {
      const value = _resolveSoundExpertInUpstreamInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInUpstream(ynode, value)
      return { field: 'in_upstream', value, written }
    }
    case 'in_prompt': {
      const value = _resolveSoundExpertInPromptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInPrompt(ynode, value)
      return { field: 'in_prompt', value, written }
    }
    case 'in_feedback': {
      const value = _resolveSoundExpertInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveSoundExpertInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    case 'in_mode': {
      const value = _resolveSoundExpertInModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInMode(ynode, value)
      return { field: 'in_mode', value, written }
    }
    case 'in_duration': {
      const value = _resolveSoundExpertInDurationInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInDuration(ynode, value)
      return { field: 'in_duration', value, written }
    }
    case 'in_voice_profile': {
      const value = _resolveSoundExpertInVoiceProfileInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInVoiceProfile(ynode, value)
      return { field: 'in_voice_profile', value, written }
    }
    case 'in_text': {
      const value = _resolveSoundExpertInTextInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInText(ynode, value)
      return { field: 'in_text', value, written }
    }
    case 'in_model': {
      const value = _resolveSoundExpertInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_loop': {
      const value = _resolveSoundExpertInLoopInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInLoop(ynode, value)
      return { field: 'in_loop', value, written }
    }
    case 'in_lyrics_mode': {
      const value = _resolveSoundExpertInLyricsModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInLyricsMode(ynode, value)
      return { field: 'in_lyrics_mode', value, written }
    }
    case 'in_voice_map': {
      const value = _resolveSoundExpertInVoiceMapInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInVoiceMap(ynode, value)
      return { field: 'in_voice_map', value, written }
    }
    case 'in_scene_id': {
      const value = _resolveSoundExpertInSceneIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInSceneId(ynode, value)
      return { field: 'in_scene_id', value, written }
    }
    case 'in_panel_index': {
      const value = _resolveSoundExpertInPanelIndexInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInPanelIndex(ynode, value)
      return { field: 'in_panel_index', value, written }
    }
    case 'in_pause_ms': {
      const value = _resolveSoundExpertInPauseMsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInPauseMs(ynode, value)
      return { field: 'in_pause_ms', value, written }
    }
    case 'in_character_name': {
      const value = _resolveSoundExpertInCharacterNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSoundExpertInCharacterName(ynode, value)
      return { field: 'in_character_name', value, written }
    }
    default:
      return undefined
  }
}

function _resolveSoundExpertInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_name')
  }
  return undefined
}

function _resolveSoundExpertInUpstreamInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_upstream'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_upstream')
  }
  return undefined
}

function _resolveSoundExpertInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_prompt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_prompt')
  }
  return undefined
}

function _resolveSoundExpertInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_feedback')
  }
  return undefined
}

function _resolveSoundExpertInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_feedback_history')
  }
  return undefined
}

function _resolveSoundExpertInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_mode')
  }
  return undefined
}

function _resolveSoundExpertInDurationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_duration'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_duration')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_duration')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_duration')
  }
  return undefined
}

function _resolveSoundExpertInVoiceProfileInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_voice_profile'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_voice_profiles') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_voice_profiles, edge.fromIndex, 'scriptWriter.out_voice_profiles', 'soundExpert.in_voice_profile')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_voice_profile')
  }
  return undefined
}

function _resolveSoundExpertInTextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_text'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_text')
  }
  return undefined
}

function _resolveSoundExpertInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_model')
  }
  return undefined
}

function _resolveSoundExpertInLoopInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_loop'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_loop')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_loop')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_loop')
  }
  return undefined
}

function _resolveSoundExpertInLyricsModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_lyrics_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_lyrics_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_lyrics_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_lyrics_mode')
  }
  return undefined
}

function _resolveSoundExpertInVoiceMapInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_voice_map'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_voice_map')
  }
  return undefined
}

function _resolveSoundExpertInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_scene_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_scene_id')
  }
  return undefined
}

function _resolveSoundExpertInPanelIndexInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_panel_index'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_panel_index')
  }
  return undefined
}

function _resolveSoundExpertInPauseMsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_pause_ms'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_pause_ms')
  }
  return undefined
}

function _resolveSoundExpertInCharacterNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SoundExpertNodeData['in_character_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_character_name')
  }
  return undefined
}

function _flushSpeechGeneratorInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_mode': {
      const value = _resolveSpeechGeneratorInModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInMode(ynode, value)
      return { field: 'in_mode', value, written }
    }
    case 'in_script': {
      const value = _resolveSpeechGeneratorInScriptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInScript(ynode, value)
      return { field: 'in_script', value, written }
    }
    case 'in_text': {
      const value = _resolveSpeechGeneratorInTextInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInText(ynode, value)
      return { field: 'in_text', value, written }
    }
    case 'in_character_name': {
      const value = _resolveSpeechGeneratorInCharacterNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInCharacterName(ynode, value)
      return { field: 'in_character_name', value, written }
    }
    case 'in_voice_id': {
      const value = _resolveSpeechGeneratorInVoiceIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInVoiceId(ynode, value)
      return { field: 'in_voice_id', value, written }
    }
    case 'in_voice_profile': {
      const value = _resolveSpeechGeneratorInVoiceProfileInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInVoiceProfile(ynode, value)
      return { field: 'in_voice_profile', value, written }
    }
    case 'in_voice_map': {
      const value = _resolveSpeechGeneratorInVoiceMapInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInVoiceMap(ynode, value)
      return { field: 'in_voice_map', value, written }
    }
    case 'in_scene_id': {
      const value = _resolveSpeechGeneratorInSceneIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInSceneId(ynode, value)
      return { field: 'in_scene_id', value, written }
    }
    case 'in_panel_index': {
      const value = _resolveSpeechGeneratorInPanelIndexInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInPanelIndex(ynode, value)
      return { field: 'in_panel_index', value, written }
    }
    case 'in_pause_ms': {
      const value = _resolveSpeechGeneratorInPauseMsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInPauseMs(ynode, value)
      return { field: 'in_pause_ms', value, written }
    }
    case 'in_pronunciation_guide': {
      const value = _resolveSpeechGeneratorInPronunciationGuideInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInPronunciationGuide(ynode, value)
      return { field: 'in_pronunciation_guide', value, written }
    }
    case 'in_language_code': {
      const value = _resolveSpeechGeneratorInLanguageCodeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeSpeechGeneratorInLanguageCode(ynode, value)
      return { field: 'in_language_code', value, written }
    }
    default:
      return undefined
  }
}

function _resolveSpeechGeneratorInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_mode')
  }
  return undefined
}

function _resolveSpeechGeneratorInScriptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_script'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_script')
  }
  return undefined
}

function _resolveSpeechGeneratorInTextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_text'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_text')
  }
  return undefined
}

function _resolveSpeechGeneratorInCharacterNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_character_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_character_name')
  }
  return undefined
}

function _resolveSpeechGeneratorInVoiceIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_voice_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_voice_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_voice_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_voice_id')
  }
  return undefined
}

function _resolveSpeechGeneratorInVoiceProfileInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_voice_profile'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_voice_profiles') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_voice_profiles, edge.fromIndex, 'scriptWriter.out_voice_profiles', 'speechGenerator.in_voice_profile')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_voice_profile')
  }
  return undefined
}

function _resolveSpeechGeneratorInVoiceMapInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_voice_map'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_voice_map')
  }
  return undefined
}

function _resolveSpeechGeneratorInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_scene_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_scene_id')
  }
  return undefined
}

function _resolveSpeechGeneratorInPanelIndexInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_panel_index'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_panel_index')
  }
  return undefined
}

function _resolveSpeechGeneratorInPauseMsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_pause_ms'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_pause_ms')
  }
  return undefined
}

function _resolveSpeechGeneratorInPronunciationGuideInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_pronunciation_guide'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_pronunciation_guide')
  }
  return undefined
}

function _resolveSpeechGeneratorInLanguageCodeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): SpeechGeneratorNodeData['in_language_code'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_language_code')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_language_code')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_language_code')
  }
  return undefined
}

function _flushStoryDirectionPreviewInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    default:
      return undefined
  }
  void ynode
  void nodes
  void edgeRefs
}

function _flushStoryboardDesignerInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_script': {
      const value = _resolveStoryboardDesignerInScriptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInScript(ynode, value)
      return { field: 'in_script', value, written }
    }
    case 'in_characters': {
      const value = _resolveStoryboardDesignerInCharactersInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInCharacters(ynode, value)
      return { field: 'in_characters', value, written }
    }
    case 'in_character_names': {
      const value = _resolveStoryboardDesignerInCharacterNamesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInCharacterNames(ynode, value)
      return { field: 'in_character_names', value, written }
    }
    case 'in_locations': {
      const value = _resolveStoryboardDesignerInLocationsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInLocations(ynode, value)
      return { field: 'in_locations', value, written }
    }
    case 'in_location_names': {
      const value = _resolveStoryboardDesignerInLocationNamesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInLocationNames(ynode, value)
      return { field: 'in_location_names', value, written }
    }
    case 'in_objects': {
      const value = _resolveStoryboardDesignerInObjectsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInObjects(ynode, value)
      return { field: 'in_objects', value, written }
    }
    case 'in_object_names': {
      const value = _resolveStoryboardDesignerInObjectNamesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInObjectNames(ynode, value)
      return { field: 'in_object_names', value, written }
    }
    case 'in_image': {
      const value = _resolveStoryboardDesignerInImageInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInImage(ynode, value)
      return { field: 'in_image', value, written }
    }
    case 'in_style': {
      const value = _resolveStoryboardDesignerInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_panel_count': {
      const value = _resolveStoryboardDesignerInPanelCountInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInPanelCount(ynode, value)
      return { field: 'in_panel_count', value, written }
    }
    case 'in_aspect_ratio': {
      const value = _resolveStoryboardDesignerInAspectRatioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInAspectRatio(ynode, value)
      return { field: 'in_aspect_ratio', value, written }
    }
    case 'in_scene_id': {
      const value = _resolveStoryboardDesignerInSceneIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInSceneId(ynode, value)
      return { field: 'in_scene_id', value, written }
    }
    case 'in_location': {
      const value = _resolveStoryboardDesignerInLocationInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInLocation(ynode, value)
      return { field: 'in_location', value, written }
    }
    case 'in_model': {
      const value = _resolveStoryboardDesignerInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_feedback': {
      const value = _resolveStoryboardDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_dialogue_mode': {
      const value = _resolveStoryboardDesignerInDialogueModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardDesignerInDialogueMode(ynode, value)
      return { field: 'in_dialogue_mode', value, written }
    }
    default:
      return undefined
  }
}

function _resolveStoryboardDesignerInScriptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_script'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_script')
  }
  return undefined
}

function _resolveStoryboardDesignerInCharactersInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_characters'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardDesignerNodeData['in_characters']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_characters')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInCharacterNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_character_names'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardDesignerNodeData['in_character_names']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_character_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInLocationsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_locations'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardDesignerNodeData['in_locations']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_locations')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInLocationNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_location_names'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardDesignerNodeData['in_location_names']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_location_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInObjectsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_objects'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardDesignerNodeData['in_objects']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_objects')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInObjectNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_object_names'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardDesignerNodeData['in_object_names']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_object_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_object_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_object_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_image'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_image')
  }
  return undefined
}

function _resolveStoryboardDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_style')
  }
  return undefined
}

function _resolveStoryboardDesignerInPanelCountInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_panel_count'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_panel_count')
  }
  return undefined
}

function _resolveStoryboardDesignerInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_aspect_ratio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_aspect_ratio')
  }
  return undefined
}

function _resolveStoryboardDesignerInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_scene_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_scene_id')
  }
  return undefined
}

function _resolveStoryboardDesignerInLocationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_location'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_location')
  }
  return undefined
}

function _resolveStoryboardDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_model')
  }
  return undefined
}

function _resolveStoryboardDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_feedback')
  }
  return undefined
}

function _resolveStoryboardDesignerInDialogueModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardDesignerNodeData['in_dialogue_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_dialogue_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_dialogue_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_dialogue_mode')
  }
  return undefined
}

function _flushStoryboardNoEnhanceDesignerInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_script': {
      const value = _resolveStoryboardNoEnhanceDesignerInScriptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInScript(ynode, value)
      return { field: 'in_script', value, written }
    }
    case 'in_characters': {
      const value = _resolveStoryboardNoEnhanceDesignerInCharactersInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInCharacters(ynode, value)
      return { field: 'in_characters', value, written }
    }
    case 'in_character_names': {
      const value = _resolveStoryboardNoEnhanceDesignerInCharacterNamesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInCharacterNames(ynode, value)
      return { field: 'in_character_names', value, written }
    }
    case 'in_locations': {
      const value = _resolveStoryboardNoEnhanceDesignerInLocationsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInLocations(ynode, value)
      return { field: 'in_locations', value, written }
    }
    case 'in_location_names': {
      const value = _resolveStoryboardNoEnhanceDesignerInLocationNamesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInLocationNames(ynode, value)
      return { field: 'in_location_names', value, written }
    }
    case 'in_style': {
      const value = _resolveStoryboardNoEnhanceDesignerInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_panel_count': {
      const value = _resolveStoryboardNoEnhanceDesignerInPanelCountInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInPanelCount(ynode, value)
      return { field: 'in_panel_count', value, written }
    }
    case 'in_scene_id': {
      const value = _resolveStoryboardNoEnhanceDesignerInSceneIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInSceneId(ynode, value)
      return { field: 'in_scene_id', value, written }
    }
    case 'in_location': {
      const value = _resolveStoryboardNoEnhanceDesignerInLocationInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInLocation(ynode, value)
      return { field: 'in_location', value, written }
    }
    case 'in_model': {
      const value = _resolveStoryboardNoEnhanceDesignerInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeStoryboardNoEnhanceDesignerInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    default:
      return undefined
  }
}

function _resolveStoryboardNoEnhanceDesignerInScriptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_script'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_script')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInCharactersInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_characters'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardNoEnhanceDesignerNodeData['in_characters']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_characters')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInCharacterNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_character_names'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardNoEnhanceDesignerNodeData['in_character_names']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_character_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInLocationsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_locations'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardNoEnhanceDesignerNodeData['in_locations']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_locations')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInLocationNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_location_names'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<StoryboardNoEnhanceDesignerNodeData['in_location_names']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_location_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_style')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInPanelCountInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_panel_count'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_panel_count')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_scene_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_scene_id')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInLocationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_location'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_location')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): StoryboardNoEnhanceDesignerNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_model')
  }
  return undefined
}

function _flushTextInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_input': {
      const value = _resolveTextInInputInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeTextInInput(ynode, value)
      return { field: 'in_input', value, written }
    }
    default:
      return undefined
  }
}

function _resolveTextInInputInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): TextNodeData['in_input'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'text.in_input')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'text.in_input')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'text.in_input')
  }
  return undefined
}

function _flushVideoInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_file_name': {
      const value = _resolveVideoInFileNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoInFileName(ynode, value)
      return { field: 'in_file_name', value, written }
    }
    case 'in_source': {
      const value = _resolveVideoInSourceInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoInSource(ynode, value)
      return { field: 'in_source', value, written }
    }
    default:
      return undefined
  }
}

function _resolveVideoInFileNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoNodeData['in_file_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'video.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'video.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_file_name')
  }
  return undefined
}

function _resolveVideoInSourceInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoNodeData['in_source'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'video.in_source')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'video.in_source')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'video.in_source')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_source')
  }
  return undefined
}

function _flushVideoEditorInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_videos': {
      const value = _resolveVideoEditorInVideosInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInVideos(ynode, value)
      return { field: 'in_videos', value, written }
    }
    case 'in_audios': {
      const value = _resolveVideoEditorInAudiosInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInAudios(ynode, value)
      return { field: 'in_audios', value, written }
    }
    case 'in_audio': {
      const value = _resolveVideoEditorInAudioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInAudio(ynode, value)
      return { field: 'in_audio', value, written }
    }
    case 'in_mode': {
      const value = _resolveVideoEditorInModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInMode(ynode, value)
      return { field: 'in_mode', value, written }
    }
    case 'in_output_name': {
      const value = _resolveVideoEditorInOutputNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInOutputName(ynode, value)
      return { field: 'in_output_name', value, written }
    }
    case 'in_start': {
      const value = _resolveVideoEditorInStartInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInStart(ynode, value)
      return { field: 'in_start', value, written }
    }
    case 'in_end': {
      const value = _resolveVideoEditorInEndInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInEnd(ynode, value)
      return { field: 'in_end', value, written }
    }
    case 'in_volume': {
      const value = _resolveVideoEditorInVolumeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInVolume(ynode, value)
      return { field: 'in_volume', value, written }
    }
    case 'in_timeline_config': {
      const value = _resolveVideoEditorInTimelineConfigInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInTimelineConfig(ynode, value)
      return { field: 'in_timeline_config', value, written }
    }
    case 'in_export_name': {
      const value = _resolveVideoEditorInExportNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInExportName(ynode, value)
      return { field: 'in_export_name', value, written }
    }
    case 'in_name': {
      const value = _resolveVideoEditorInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoEditorInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    default:
      return undefined
  }
}

function _resolveVideoEditorInVideosInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_videos'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<VideoEditorNodeData['in_videos']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'videoEditor.in_videos')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'videoEditor.in_videos')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'videoEditor.in_videos')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_videos')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoEditorInAudiosInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_audios'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<VideoEditorNodeData['in_audios']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'videoEditor.in_audios')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'videoEditor.in_audios')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'videoEditor.in_audios')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_audios')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoEditorInAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_audio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'videoEditor.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'videoEditor.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'videoEditor.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_audio')
  }
  return undefined
}

function _resolveVideoEditorInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoEditor.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoEditor.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_mode')
  }
  return undefined
}

function _resolveVideoEditorInOutputNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_output_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoEditor.in_output_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoEditor.in_output_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_output_name')
  }
  return undefined
}

function _resolveVideoEditorInStartInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_start'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_start')
  }
  return undefined
}

function _resolveVideoEditorInEndInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_end'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_end')
  }
  return undefined
}

function _resolveVideoEditorInVolumeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_volume'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_volume')
  }
  return undefined
}

function _resolveVideoEditorInTimelineConfigInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_timeline_config'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_timeline_config')
  }
  return undefined
}

function _resolveVideoEditorInExportNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_export_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoEditor.in_export_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoEditor.in_export_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_export_name')
  }
  return undefined
}

function _resolveVideoEditorInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoEditorNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoEditor.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoEditor.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_name')
  }
  return undefined
}

function _flushVideoGeneratorInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_mode': {
      const value = _resolveVideoGeneratorInModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInMode(ynode, value)
      return { field: 'in_mode', value, written }
    }
    case 'in_scene_id': {
      const value = _resolveVideoGeneratorInSceneIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInSceneId(ynode, value)
      return { field: 'in_scene_id', value, written }
    }
    case 'in_clip_number': {
      const value = _resolveVideoGeneratorInClipNumberInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInClipNumber(ynode, value)
      return { field: 'in_clip_number', value, written }
    }
    case 'in_images': {
      const value = _resolveVideoGeneratorInImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInImages(ynode, value)
      return { field: 'in_images', value, written }
    }
    case 'in_audio': {
      const value = _resolveVideoGeneratorInAudioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInAudio(ynode, value)
      return { field: 'in_audio', value, written }
    }
    case 'in_motion_prompt': {
      const value = _resolveVideoGeneratorInMotionPromptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInMotionPrompt(ynode, value)
      return { field: 'in_motion_prompt', value, written }
    }
    case 'in_feedback': {
      const value = _resolveVideoGeneratorInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveVideoGeneratorInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    case 'in_scene_context': {
      const value = _resolveVideoGeneratorInSceneContextInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInSceneContext(ynode, value)
      return { field: 'in_scene_context', value, written }
    }
    case 'in_duration': {
      const value = _resolveVideoGeneratorInDurationInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInDuration(ynode, value)
      return { field: 'in_duration', value, written }
    }
    case 'in_dialogue_prompt': {
      const value = _resolveVideoGeneratorInDialoguePromptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInDialoguePrompt(ynode, value)
      return { field: 'in_dialogue_prompt', value, written }
    }
    case 'in_model': {
      const value = _resolveVideoGeneratorInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_aspect_ratio': {
      const value = _resolveVideoGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInAspectRatio(ynode, value)
      return { field: 'in_aspect_ratio', value, written }
    }
    case 'in_resolution': {
      const value = _resolveVideoGeneratorInResolutionInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInResolution(ynode, value)
      return { field: 'in_resolution', value, written }
    }
    case 'in_generate_audio': {
      const value = _resolveVideoGeneratorInGenerateAudioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInGenerateAudio(ynode, value)
      return { field: 'in_generate_audio', value, written }
    }
    case 'in_tts_provider': {
      const value = _resolveVideoGeneratorInTtsProviderInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInTtsProvider(ynode, value)
      return { field: 'in_tts_provider', value, written }
    }
    case 'in_voice_profiles': {
      const value = _resolveVideoGeneratorInVoiceProfilesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInVoiceProfiles(ynode, value)
      return { field: 'in_voice_profiles', value, written }
    }
    case 'in_voice_settings': {
      const value = _resolveVideoGeneratorInVoiceSettingsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInVoiceSettings(ynode, value)
      return { field: 'in_voice_settings', value, written }
    }
    case 'in_name': {
      const value = _resolveVideoGeneratorInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_resolved_voice_map': {
      const value = _resolveVideoGeneratorInResolvedVoiceMapInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInResolvedVoiceMap(ynode, value)
      return { field: 'in_resolved_voice_map', value, written }
    }
    case 'in_audio_remix_config': {
      const value = _resolveVideoGeneratorInAudioRemixConfigInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInAudioRemixConfig(ynode, value)
      return { field: 'in_audio_remix_config', value, written }
    }
    case 'in_dialogue_mode': {
      const value = _resolveVideoGeneratorInDialogueModeInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInDialogueMode(ynode, value)
      return { field: 'in_dialogue_mode', value, written }
    }
    case 'in_style_anchor': {
      const value = _resolveVideoGeneratorInStyleAnchorInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInStyleAnchor(ynode, value)
      return { field: 'in_style_anchor', value, written }
    }
    case 'in_storyboard_meta': {
      const value = _resolveVideoGeneratorInStoryboardMetaInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeVideoGeneratorInStoryboardMeta(ynode, value)
      return { field: 'in_storyboard_meta', value, written }
    }
    default:
      return undefined
  }
}

function _resolveVideoGeneratorInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_mode')
  }
  return undefined
}

function _resolveVideoGeneratorInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_scene_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_scene_id')
  }
  return undefined
}

function _resolveVideoGeneratorInClipNumberInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_clip_number'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_clip_number')
  }
  return undefined
}

function _resolveVideoGeneratorInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_images'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<VideoGeneratorNodeData['in_images']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoGeneratorInAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_audio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'videoGenerator.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'videoGenerator.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'videoGenerator.in_audio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_audio')
  }
  return undefined
}

function _resolveVideoGeneratorInMotionPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_motion_prompt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_motion_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_motion_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_motion_prompt')
  }
  return undefined
}

function _resolveVideoGeneratorInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_feedback')
  }
  return undefined
}

function _resolveVideoGeneratorInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_feedback_history')
  }
  return undefined
}

function _resolveVideoGeneratorInSceneContextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_scene_context'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_scene_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_scene_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_scene_context')
  }
  return undefined
}

function _resolveVideoGeneratorInDurationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_duration'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_actual_duration_seconds') {
      const value = sourceNode.data?.out_actual_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_duration')
  }
  return undefined
}

function _resolveVideoGeneratorInDialoguePromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_dialogue_prompt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_auto_dialogue') {
      const value = sourceNode.data?.out_auto_dialogue
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_dialogue_prompt')
  }
  return undefined
}

function _resolveVideoGeneratorInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_model')
  }
  return undefined
}

function _resolveVideoGeneratorInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_aspect_ratio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_aspect_ratio')
  }
  return undefined
}

function _resolveVideoGeneratorInResolutionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_resolution'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_resolution')
  }
  return undefined
}

function _resolveVideoGeneratorInGenerateAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_generate_audio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_generate_audio')
  }
  return undefined
}

function _resolveVideoGeneratorInTtsProviderInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_tts_provider'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_tts_provider')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_tts_provider')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_tts_provider')
  }
  return undefined
}

function _resolveVideoGeneratorInVoiceProfilesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_voice_profiles'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<VideoGeneratorNodeData['in_voice_profiles']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_voice_profiles') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_voice_profiles, edge.fromIndex, 'scriptWriter.out_voice_profiles', 'videoGenerator.in_voice_profiles')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_voice_profiles
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_voice_profiles')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoGeneratorInVoiceSettingsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_voice_settings'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_voice_settings')
  }
  return undefined
}

function _resolveVideoGeneratorInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_name')
  }
  return undefined
}

function _resolveVideoGeneratorInResolvedVoiceMapInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_resolved_voice_map'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_resolved_voice_map')
  }
  return undefined
}

function _resolveVideoGeneratorInAudioRemixConfigInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_audio_remix_config'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_audio_remix_baseline') {
      const value = sourceNode.data?.out_audio_remix_baseline
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_audio_remix_config')
  }
  return undefined
}

function _resolveVideoGeneratorInDialogueModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_dialogue_mode'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_dialogue_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_dialogue_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_dialogue_mode')
  }
  return undefined
}

function _resolveVideoGeneratorInStyleAnchorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_style_anchor'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_style_anchor')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_style_anchor')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_style_anchor')
  }
  return undefined
}

function _resolveVideoGeneratorInStoryboardMetaInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): VideoGeneratorNodeData['in_storyboard_meta'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_storyboard_meta')
  }
  return undefined
}

function _flushWebtoonGroupInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_scene_id': {
      const value = _resolveWebtoonGroupInSceneIdInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonGroupInSceneId(ynode, value)
      return { field: 'in_scene_id', value, written }
    }
    case 'in_label': {
      const value = _resolveWebtoonGroupInLabelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonGroupInLabel(ynode, value)
      return { field: 'in_label', value, written }
    }
    case 'in_collapsed': {
      const value = _resolveWebtoonGroupInCollapsedInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonGroupInCollapsed(ynode, value)
      return { field: 'in_collapsed', value, written }
    }
    case 'in_child_node_ids': {
      const value = _resolveWebtoonGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonGroupInChildNodeIds(ynode, value)
      return { field: 'in_child_node_ids', value, written }
    }
    default:
      return undefined
  }
}

function _resolveWebtoonGroupInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonGroupNodeData['in_scene_id'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonGroup.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonGroup.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_scene_id')
  }
  return undefined
}

function _resolveWebtoonGroupInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonGroupNodeData['in_label'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_label')
  }
  return undefined
}

function _resolveWebtoonGroupInCollapsedInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonGroupNodeData['in_collapsed'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_collapsed')
  }
  return undefined
}

function _resolveWebtoonGroupInChildNodeIdsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonGroupNodeData['in_child_node_ids'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'screenplayWriter') && edge.sourceHandle === 'out_music_prompts') {
      const value = sourceNode.data?.out_music_prompts
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'webtoonGroup.in_child_node_ids')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_child_node_ids')
  }
  return undefined
}

function _flushWebtoonPanelGeneratorInputFromEdgeRefs(
  ynode: Y.Map<YDocValue>,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  switch (targetHandle) {
    case 'in_images': {
      const value = _resolveWebtoonPanelGeneratorInImagesInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInImages(ynode, value)
      return { field: 'in_images', value, written }
    }
    case 'in_prompt': {
      const value = _resolveWebtoonPanelGeneratorInPromptInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInPrompt(ynode, value)
      return { field: 'in_prompt', value, written }
    }
    case 'in_beats': {
      const value = _resolveWebtoonPanelGeneratorInBeatsInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInBeats(ynode, value)
      return { field: 'in_beats', value, written }
    }
    case 'in_dialogue': {
      const value = _resolveWebtoonPanelGeneratorInDialogueInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInDialogue(ynode, value)
      return { field: 'in_dialogue', value, written }
    }
    case 'in_panel_index': {
      const value = _resolveWebtoonPanelGeneratorInPanelIndexInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInPanelIndex(ynode, value)
      return { field: 'in_panel_index', value, written }
    }
    case 'in_aspect_ratio': {
      const value = _resolveWebtoonPanelGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInAspectRatio(ynode, value)
      return { field: 'in_aspect_ratio', value, written }
    }
    case 'in_layout': {
      const value = _resolveWebtoonPanelGeneratorInLayoutInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInLayout(ynode, value)
      return { field: 'in_layout', value, written }
    }
    case 'in_style': {
      const value = _resolveWebtoonPanelGeneratorInStyleInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInStyle(ynode, value)
      return { field: 'in_style', value, written }
    }
    case 'in_model': {
      const value = _resolveWebtoonPanelGeneratorInModelInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInModel(ynode, value)
      return { field: 'in_model', value, written }
    }
    case 'in_name': {
      const value = _resolveWebtoonPanelGeneratorInNameInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInName(ynode, value)
      return { field: 'in_name', value, written }
    }
    case 'in_feedback': {
      const value = _resolveWebtoonPanelGeneratorInFeedbackInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInFeedback(ynode, value)
      return { field: 'in_feedback', value, written }
    }
    case 'in_feedback_history': {
      const value = _resolveWebtoonPanelGeneratorInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
      if (value === undefined) return undefined
      const written = writeWebtoonPanelGeneratorInFeedbackHistory(ynode, value)
      return { field: 'in_feedback_history', value, written }
    }
    default:
      return undefined
  }
}

function _resolveWebtoonPanelGeneratorInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_images'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<WebtoonPanelGeneratorNodeData['in_images']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'directorStage') && edge.sourceHandle === 'out_captures') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_captures, edge.fromIndex, 'directorStage.out_captures', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_captures
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'remotionComposer') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_song') {
      const value = sourceNode.data?.out_song
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_storyboard_grid, edge.fromIndex, 'storyboardDesigner.out_storyboard_grid', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_remixed_video') {
      const value = sourceNode.data?.out_remixed_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_replacement_mix') {
      const value = sourceNode.data?.out_replacement_mix
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveWebtoonPanelGeneratorInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_prompt'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_prompt')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInBeatsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_beats'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<WebtoonPanelGeneratorNodeData['in_beats']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_beats')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_beats')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_beats')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveWebtoonPanelGeneratorInDialogueInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_dialogue'] {
  const resolved: Array<_IndexedInputFlushValue<NonNullable<WebtoonPanelGeneratorNodeData['in_dialogue']>[number]>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    void edgeOrder
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_dialogue')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveWebtoonPanelGeneratorInPanelIndexInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_panel_index'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_frame_count') {
      const value = sourceNode.data?.out_frame_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_panel_index')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_aspect_ratio'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_aspect_ratio')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInLayoutInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_layout'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_layout')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_layout')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_layout')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_style'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_style')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_model'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_model')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_name'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_name')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_feedback'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'brandFilm') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'captioner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'hyperframeRenderer') && edge.sourceHandle === 'out_render_log') {
      const value = sourceNode.data?.out_render_log
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'singingPortrait') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.out_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_storyboard_grid') {
      const value = sourceNode.data?.out_storyboard_grid
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_feedback')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): WebtoonPanelGeneratorNodeData['in_feedback_history'] {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_feedback_history')
  }
  return undefined
}

/** Frontend type to interface type mapping (use with getTypedNodeData) */
export type FeNodeDataMap = {
  'audio': AudioNodeData
  'brandFilm': BrandFilmNodeData
  'captioner': CaptionerNodeData
  'characterDesigner': CharacterDesignerNodeData
  'debugHang': DebugHangNodeData
  'director': DirectorNodeData
  'directorStage': DirectorStageNodeData
  'generatedImageWithHistory': GeneratedImageWithHistoryNodeData
  'hyperframeRenderer': HyperframeRendererNodeData
  'image': ImageNodeData
  'imageGenerator': ImageGeneratorNodeData
  'locationDesigner': LocationDesignerNodeData
  'nodeGroup': NodeGroupNodeData
  'objectDesigner': ObjectDesignerNodeData
  'panelSource': PanelSourceNodeData
  'promptInput': PromptInputNodeData
  'remotionComposer': RemotionComposerNodeData
  'screenplayWriter': ScreenplayWriterNodeData
  'scriptWriter': ScriptWriterNodeData
  'shortVideoGroup': ShortVideoGroupNodeData
  'singingPortrait': SingingPortraitNodeData
  'soundExpert': SoundExpertNodeData
  'speechGenerator': SpeechGeneratorNodeData
  'storyDirectionPreview': StoryDirectionPreviewNodeData
  'storyboardDesigner': StoryboardDesignerNodeData
  'storyboardNoEnhanceDesigner': StoryboardNoEnhanceDesignerNodeData
  'text': TextNodeData
  'video': VideoNodeData
  'videoEditor': VideoEditorNodeData
  'videoGenerator': VideoGeneratorNodeData
  'webtoonGroup': WebtoonGroupNodeData
  'webtoonPanelGenerator': WebtoonPanelGeneratorNodeData
}

export type FeNodeType = keyof FeNodeDataMap
export type ReactFlowNodeLike = { type?: string | null; data?: object }
export type UntypedReactFlowNode = Node<object, string | undefined>
export type ReactFlowNodeByType = {
  'audio': Node<FeNodeDataMap['audio'], 'audio'>
  'brandFilm': Node<FeNodeDataMap['brandFilm'], 'brandFilm'>
  'captioner': Node<FeNodeDataMap['captioner'], 'captioner'>
  'characterDesigner': Node<FeNodeDataMap['characterDesigner'], 'characterDesigner'>
  'debugHang': Node<FeNodeDataMap['debugHang'], 'debugHang'>
  'director': Node<FeNodeDataMap['director'], 'director'>
  'directorStage': Node<FeNodeDataMap['directorStage'], 'directorStage'>
  'generatedImageWithHistory': Node<FeNodeDataMap['generatedImageWithHistory'], 'generatedImageWithHistory'>
  'hyperframeRenderer': Node<FeNodeDataMap['hyperframeRenderer'], 'hyperframeRenderer'>
  'image': Node<FeNodeDataMap['image'], 'image'>
  'imageGenerator': Node<FeNodeDataMap['imageGenerator'], 'imageGenerator'>
  'locationDesigner': Node<FeNodeDataMap['locationDesigner'], 'locationDesigner'>
  'nodeGroup': Node<FeNodeDataMap['nodeGroup'], 'nodeGroup'>
  'objectDesigner': Node<FeNodeDataMap['objectDesigner'], 'objectDesigner'>
  'panelSource': Node<FeNodeDataMap['panelSource'], 'panelSource'>
  'promptInput': Node<FeNodeDataMap['promptInput'], 'promptInput'>
  'remotionComposer': Node<FeNodeDataMap['remotionComposer'], 'remotionComposer'>
  'screenplayWriter': Node<FeNodeDataMap['screenplayWriter'], 'screenplayWriter'>
  'scriptWriter': Node<FeNodeDataMap['scriptWriter'], 'scriptWriter'>
  'shortVideoGroup': Node<FeNodeDataMap['shortVideoGroup'], 'shortVideoGroup'>
  'singingPortrait': Node<FeNodeDataMap['singingPortrait'], 'singingPortrait'>
  'soundExpert': Node<FeNodeDataMap['soundExpert'], 'soundExpert'>
  'speechGenerator': Node<FeNodeDataMap['speechGenerator'], 'speechGenerator'>
  'storyDirectionPreview': Node<FeNodeDataMap['storyDirectionPreview'], 'storyDirectionPreview'>
  'storyboardDesigner': Node<FeNodeDataMap['storyboardDesigner'], 'storyboardDesigner'>
  'storyboardNoEnhanceDesigner': Node<FeNodeDataMap['storyboardNoEnhanceDesigner'], 'storyboardNoEnhanceDesigner'>
  'text': Node<FeNodeDataMap['text'], 'text'>
  'video': Node<FeNodeDataMap['video'], 'video'>
  'videoEditor': Node<FeNodeDataMap['videoEditor'], 'videoEditor'>
  'videoGenerator': Node<FeNodeDataMap['videoGenerator'], 'videoGenerator'>
  'webtoonGroup': Node<FeNodeDataMap['webtoonGroup'], 'webtoonGroup'>
  'webtoonPanelGenerator': Node<FeNodeDataMap['webtoonPanelGenerator'], 'webtoonPanelGenerator'>
}
export type TypedReactFlowNode<T extends FeNodeType = FeNodeType> = T extends FeNodeType ? ReactFlowNodeByType[T] : never
export type AnyTypedReactFlowNode = TypedReactFlowNode
export const FE_NODE_TYPES: ReadonlyArray<FeNodeType> = [
  'audio',
  'brandFilm',
  'captioner',
  'characterDesigner',
  'debugHang',
  'director',
  'directorStage',
  'generatedImageWithHistory',
  'hyperframeRenderer',
  'image',
  'imageGenerator',
  'locationDesigner',
  'nodeGroup',
  'objectDesigner',
  'panelSource',
  'promptInput',
  'remotionComposer',
  'screenplayWriter',
  'scriptWriter',
  'shortVideoGroup',
  'singingPortrait',
  'soundExpert',
  'speechGenerator',
  'storyDirectionPreview',
  'storyboardDesigner',
  'storyboardNoEnhanceDesigner',
  'text',
  'video',
  'videoEditor',
  'videoGenerator',
  'webtoonGroup',
  'webtoonPanelGenerator',
]

export function isFeNodeType(type: string | null | undefined): type is FeNodeType {
  return typeof type === 'string' && FE_NODE_TYPES.some((candidate) => candidate === type)
}

export function isTypedReactFlowNode<T extends FeNodeType>(
  node: UntypedReactFlowNode,
  type: T,
): node is TypedReactFlowNode<T> {
  return node.type === type
}

/** Type-narrow ReactFlow node.data by frontend node type */
export function getTypedNodeData<T extends FeNodeType>(node: TypedReactFlowNode<T>, type: T): FeNodeDataMap[T]
export function getTypedNodeData<T extends FeNodeType>(node: ReactFlowNodeLike, type: T): FeNodeDataMap[T] | undefined
export function getTypedNodeData(node: ReactFlowNodeLike, type: FeNodeType): object | undefined {
  if (node.type !== type) return undefined
  return node.data
}

export function requireTypedNodeData<T extends FeNodeType>(
  node: ReactFlowNodeLike,
  type: T,
  helper = 'requireTypedNodeData',
): FeNodeDataMap[T] {
  const data = getTypedNodeData(node, type)
  if (!data) {
    const renderedType = node.type ?? '<missing>'
    throw new Error(`${helper}: expected node type ${type}, received ${renderedType}`)
  }
  return data
}

function _throwUnknownNodeType(type: string | null | undefined, helper: string): never {
  const renderedType = type ?? '<missing>'
  throw new Error(`${helper}: unsupported node type ${renderedType}`)
}

function _firstNonEmptyNodeString(...values: Array<string | undefined>): string | undefined {
  for (const value of values) {
    const trimmed = value?.trim()
    if (trimmed) return trimmed
  }
  return undefined
}

/**
 * Schema-generated summary text for a node.
 * Known node types without configured description-like string fields return undefined.
 * Unknown node types throw so stale UI code does not silently hide schema drift.
 */
export function getNodeDescription(node: { type?: string | null; data?: object }): string | undefined {
  switch (node.type) {
    case 'audio': {
      return undefined
    }
    case 'brandFilm': {
      return undefined
    }
    case 'captioner': {
      return undefined
    }
    case 'characterDesigner': {
      const data = getTypedNodeData(node, 'characterDesigner')
      return _firstNonEmptyNodeString(data?.in_description)
    }
    case 'debugHang': {
      return undefined
    }
    case 'director': {
      return undefined
    }
    case 'directorStage': {
      return undefined
    }
    case 'generatedImageWithHistory': {
      return undefined
    }
    case 'hyperframeRenderer': {
      return undefined
    }
    case 'image': {
      return undefined
    }
    case 'imageGenerator': {
      const data = getTypedNodeData(node, 'imageGenerator')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    case 'locationDesigner': {
      const data = getTypedNodeData(node, 'locationDesigner')
      return _firstNonEmptyNodeString(data?.in_description)
    }
    case 'nodeGroup': {
      return undefined
    }
    case 'objectDesigner': {
      const data = getTypedNodeData(node, 'objectDesigner')
      return _firstNonEmptyNodeString(data?.in_description)
    }
    case 'panelSource': {
      const data = getTypedNodeData(node, 'panelSource')
      return _firstNonEmptyNodeString(data?.out_action)
    }
    case 'promptInput': {
      const data = getTypedNodeData(node, 'promptInput')
      return _firstNonEmptyNodeString(data?.out_prompt)
    }
    case 'remotionComposer': {
      return undefined
    }
    case 'screenplayWriter': {
      const data = getTypedNodeData(node, 'screenplayWriter')
      return _firstNonEmptyNodeString(data?.in_user_script)
    }
    case 'scriptWriter': {
      const data = getTypedNodeData(node, 'scriptWriter')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    case 'shortVideoGroup': {
      return undefined
    }
    case 'singingPortrait': {
      const data = getTypedNodeData(node, 'singingPortrait')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    case 'soundExpert': {
      const data = getTypedNodeData(node, 'soundExpert')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    case 'speechGenerator': {
      const data = getTypedNodeData(node, 'speechGenerator')
      return _firstNonEmptyNodeString(data?.in_script)
    }
    case 'storyDirectionPreview': {
      return undefined
    }
    case 'storyboardDesigner': {
      const data = getTypedNodeData(node, 'storyboardDesigner')
      return _firstNonEmptyNodeString(data?.in_script)
    }
    case 'storyboardNoEnhanceDesigner': {
      const data = getTypedNodeData(node, 'storyboardNoEnhanceDesigner')
      return _firstNonEmptyNodeString(data?.in_script)
    }
    case 'text': {
      const data = getTypedNodeData(node, 'text')
      return _firstNonEmptyNodeString(data?.out_text, data?.in_input)
    }
    case 'video': {
      return undefined
    }
    case 'videoEditor': {
      return undefined
    }
    case 'videoGenerator': {
      const data = getTypedNodeData(node, 'videoGenerator')
      return _firstNonEmptyNodeString(data?.in_motion_prompt, data?.in_scene_context)
    }
    case 'webtoonGroup': {
      return undefined
    }
    case 'webtoonPanelGenerator': {
      const data = getTypedNodeData(node, 'webtoonPanelGenerator')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    default:
      return _throwUnknownNodeType(node.type, 'getNodeDescription')
  }
}

export type YDocWireType = 'primitive' | 'json' | 'array' | 'map'

export interface YDocFieldDef {
  schemaType: string
  wireType: YDocWireType
  isMulti: boolean
  baseType: string
  allowsNullItems?: boolean
}

export const YDOC_NODE_FIELDS: Record<string, Record<string, YDocFieldDef>> = {
  audio: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  brand_film: {
    in_plan: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_clips: { schemaType: 'video', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_voiceover: { schemaType: 'audio', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_music: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_render_log: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  captioner: {
    in_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_language: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_caption_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_transcript: { schemaType: 'CaptionWordDict', wireType: 'array', isMulti: true, baseType: 'CaptionWordDict' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  character_designer: {
    in_upstream: { schemaType: 'UpstreamContextDict', wireType: 'json', isMulti: false, baseType: 'UpstreamContextDict' },
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_ref_images: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_role: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    in_pronunciation_guide: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_descriptor: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_character_sheet: { schemaType: 'image', wireType: 'json', isMulti: false, baseType: 'CharacterAsset' },
    out_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'json', isMulti: false, baseType: 'VoiceProfileDict' },
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  debug_hang: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_result: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  director: {
    in_context: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_response: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_crew: { schemaType: 'DirectorCrewDict', wireType: 'json', isMulti: false, baseType: 'DirectorCrewDict' },
  },
  director_stage: {
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_scene: { schemaType: 'Stage3dSceneDocDict', wireType: 'json', isMulti: false, baseType: 'Stage3dSceneDocDict' },
    out_captures: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
  },
  generated_image_with_history: {
  },
  hyperframe_renderer: {
    in_template_html: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_props_json: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_media: { schemaType: 'video', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_resolution: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_fps: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_strict_lint: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_render_log: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_actual_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    out_frame_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
  },
  image: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_source: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  image_generator: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_ref_images: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    in_upstream: { schemaType: 'UpstreamContextDict', wireType: 'json', isMulti: false, baseType: 'UpstreamContextDict' },
    in_storyboard_meta: { schemaType: 'StoryboardDecomposeMetaDict', wireType: 'json', isMulti: false, baseType: 'StoryboardDecomposeMetaDict' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'AspectRatio' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_quality: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_panel_refs: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    in_update: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_video: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_frame: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_get_frame: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    out_generated_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'GeneratedImageWithHistory' },
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  location_designer: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_ref_images: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_time_of_day: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_weather: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_location_image: { schemaType: 'image', wireType: 'json', isMulti: false, baseType: 'LocationAsset' },
    out_metadata: { schemaType: 'LocationMetadataDict', wireType: 'json', isMulti: false, baseType: 'LocationMetadataDict' },
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  node_group: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str | None]', allowsNullItems: true },
    in_layout_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  object_designer: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_ref_images: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_object_image: { schemaType: 'image', wireType: 'json', isMulti: false, baseType: 'ObjectAsset' },
    out_metadata: { schemaType: 'ObjectMetadataDict', wireType: 'json', isMulti: false, baseType: 'ObjectMetadataDict' },
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  panel_source: {
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_action: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_character_ids: { schemaType: 'string[]', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    out_appearances: { schemaType: 'list[AppearanceDict]', wireType: 'array', isMulti: false, baseType: 'list[AppearanceDict]' },
    out_dialogue: { schemaType: 'list[PanelDialogueDict]', wireType: 'array', isMulti: false, baseType: 'list[PanelDialogueDict]' },
    out_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_composition: { schemaType: 'CompositionDict', wireType: 'json', isMulti: false, baseType: 'CompositionDict' },
  },
  prompt_input: {
    out_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  remotion_composer: {
    in_clip: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_clips: { schemaType: 'video', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_brand_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_tagline: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_captions: { schemaType: 'AdCaptionsDict', wireType: 'json', isMulti: false, baseType: 'AdCaptionsDict' },
    in_composition_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_aspect: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_clip_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  screenplay_writer: {
    in_story_context: { schemaType: 'StoryContextDict', wireType: 'json', isMulti: false, baseType: 'StoryContextDict' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_user_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_panels: { schemaType: 'list[PanelDescriptionDict]', wireType: 'array', isMulti: false, baseType: 'list[PanelDescriptionDict]' },
    out_transitions: { schemaType: 'list[TransitionDict]', wireType: 'array', isMulti: false, baseType: 'list[TransitionDict]' },
    out_dialogue: { schemaType: 'list[ScriptDialogueDict]', wireType: 'array', isMulti: false, baseType: 'list[ScriptDialogueDict]' },
    out_music_prompts: { schemaType: 'string[]', wireType: 'array', isMulti: false, baseType: 'list[str]' },
  },
  script_writer: {
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_active_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_director_instruction: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_format_only: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_gemini: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_claude: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_gpt: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_characters: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_target_duration_s: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_ending: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_review_history: { schemaType: 'list[ReviewHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[ReviewHistoryEntryDict]' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_script_path: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_screenplay: { schemaType: 'list[ScriptScreenplaySceneDict]', wireType: 'array', isMulti: false, baseType: 'list[ScriptScreenplaySceneDict]' },
    out_dialogue: { schemaType: 'list[ScriptDialogueDict]', wireType: 'array', isMulti: false, baseType: 'list[ScriptDialogueDict]' },
    out_voice_roles: { schemaType: 'VoiceRoleDict', wireType: 'array', isMulti: true, baseType: 'VoiceRoleDict' },
    out_voice_profiles: { schemaType: 'VoiceProfileDict', wireType: 'array', isMulti: true, baseType: 'VoiceProfileDict' },
    out_action_lines: { schemaType: 'list[SceneTextDict]', wireType: 'array', isMulti: false, baseType: 'list[SceneTextDict]' },
    out_characters: { schemaType: 'string[]', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    out_music_cues: { schemaType: 'list[SceneTextDict]', wireType: 'array', isMulti: false, baseType: 'list[SceneTextDict]' },
    out_sfx: { schemaType: 'list[SceneTextDict]', wireType: 'array', isMulti: false, baseType: 'list[SceneTextDict]' },
    out_gemini: { schemaType: 'ScreenplayResultDict', wireType: 'json', isMulti: false, baseType: 'ScreenplayResultDict' },
    out_claude: { schemaType: 'ScreenplayResultDict', wireType: 'json', isMulti: false, baseType: 'ScreenplayResultDict' },
    out_gpt: { schemaType: 'ScreenplayResultDict', wireType: 'json', isMulti: false, baseType: 'ScreenplayResultDict' },
    out_locations: { schemaType: 'string[]', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    out_active_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_scene_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
  },
  short_video_group: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_collapsed: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_storyboard_path: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
  },
  singing_portrait: {
    in_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_audio_start_s: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_lyrics: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_song_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_motion: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_scenes: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_duration: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_song: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  sound_expert: {
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_upstream: { schemaType: 'UpstreamContextDict', wireType: 'json', isMulti: false, baseType: 'UpstreamContextDict' },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_duration: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'json', isMulti: false, baseType: 'VoiceProfileDict' },
    in_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_loop: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_lyrics_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_map: { schemaType: 'VoiceMapDict', wireType: 'json', isMulti: false, baseType: 'VoiceMapDict' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_pause_ms: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_character_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_generated_audio: { schemaType: 'SoundGeneratedAudioDict', wireType: 'json', isMulti: false, baseType: 'SoundGeneratedAudioDict' },
  },
  speech_generator: {
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_character_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'json', isMulti: false, baseType: 'VoiceProfileDict' },
    in_voice_map: { schemaType: 'VoiceMapDict', wireType: 'json', isMulti: false, baseType: 'VoiceMapDict' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_pause_ms: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_pronunciation_guide: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_language_code: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    out_waveform: { schemaType: 'list[float]', wireType: 'array', isMulti: false, baseType: 'list[float]' },
    out_generated_audio: { schemaType: 'SoundGeneratedAudioDict', wireType: 'json', isMulti: false, baseType: 'SoundGeneratedAudioDict' },
  },
  story_direction_preview: {
  },
  storyboard_designer: {
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_character_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_location_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_objects: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_object_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_panel_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_location: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_dialogue_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_storyboard_grid: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    out_metadata: { schemaType: 'StoryboardMetadataDict', wireType: 'json', isMulti: false, baseType: 'StoryboardMetadataDict' },
    out_beats: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    out_panel_refs: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'list[str]' },
    out_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    out_grid_descriptions: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
  },
  storyboard_no_enhance_designer: {
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_character_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_location_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_panel_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_location: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_storyboard_grid: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  text: {
    in_input: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  video: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_source: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  video_editor: {
    in_videos: { schemaType: 'video', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_audios: { schemaType: 'audio', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_output_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_start: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_end: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_volume: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_timeline_config: { schemaType: 'TimelineConfigDict', wireType: 'json', isMulti: false, baseType: 'TimelineConfigDict' },
    in_export_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  video_generator: {
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_clip_number: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_motion_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    in_scene_context: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_duration: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_dialogue_prompt: { schemaType: 'list[DialogueEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[DialogueEntryDict]' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_resolution: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_generate_audio: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_tts_provider: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_profiles: { schemaType: 'VoiceProfileDict', wireType: 'array', isMulti: true, baseType: 'VoiceProfileDict', allowsNullItems: true },
    in_voice_settings: { schemaType: 'VoiceSettingsDict', wireType: 'json', isMulti: false, baseType: 'VoiceSettingsDict' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_resolved_voice_map: { schemaType: 'ResolvedVoiceMapDict', wireType: 'map', isMulti: false, baseType: 'ResolvedVoiceMapDict' },
    in_audio_remix_config: { schemaType: 'AudioRemixConfigDict', wireType: 'json', isMulti: false, baseType: 'AudioRemixConfigDict' },
    in_dialogue_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style_anchor: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_storyboard_meta: { schemaType: 'StoryboardDecomposeMetaDict', wireType: 'json', isMulti: false, baseType: 'StoryboardDecomposeMetaDict' },
    out_generated_video: { schemaType: 'video', wireType: 'map', isMulti: false, baseType: 'GeneratedVideoWithHistory' },
    out_remixed_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_replacement_mix: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_tts_segments: { schemaType: 'list[TtsSegmentDict]', wireType: 'array', isMulti: false, baseType: 'list[TtsSegmentDict]' },
    out_audio_remix_baseline: { schemaType: 'AudioRemixConfigDict', wireType: 'json', isMulti: false, baseType: 'AudioRemixConfigDict' },
    out_auto_dialogue: { schemaType: 'list[DialogueEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[DialogueEntryDict]' },
    out_speech_windows: { schemaType: 'list[SpeechWindowDict]', wireType: 'array', isMulti: false, baseType: 'list[SpeechWindowDict]' },
    out_video_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video_duration: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    out_dialogue: { schemaType: 'list[ReconciledDialogueEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[ReconciledDialogueEntryDict]' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  webtoon_group: {
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_collapsed: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
  },
  webtoon_panel_generator: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath', allowsNullItems: true },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_beats: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', allowsNullItems: true },
    in_dialogue: { schemaType: 'WebtoonDialogueDict', wireType: 'array', isMulti: true, baseType: 'WebtoonDialogueDict', allowsNullItems: true },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_layout: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]' },
    out_panel_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'GeneratedImageWithHistory' },
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
}

// ---------------------------------------------------------------------------
// YDoc deserializer helpers (schema-driven, replaces heuristic parsing)
// ---------------------------------------------------------------------------

function _ydocPassthrough(v: YDocValue): YDocValue {
  if (v instanceof Y.Array) return v.toArray()
  return v
}

function _ydocParseJson(v: YDocValue): YDocValue {
  if (v instanceof Y.Array) return v.toArray()
  if (typeof v === 'string') { try { return JSON.parse(v) } catch { return v } }
  return v
}

function _ydocParseArray(v: YDocValue): YDocValue {
  if (v instanceof Y.Array) return v.toArray()
  return v
}

function _ydocParseMap(v: YDocValue): YDocValue {
  if (v instanceof Y.Map) {
    // GeneratedImageWithHistory shape: has 'history' key
    if (v.get('history') !== undefined) {
      const histArr = v.get('history')
      let history: YDocValue[]
      if (histArr instanceof Y.Array) {
        history = histArr.toArray().map((item: YDocValue) =>
          typeof item === 'string' ? JSON.parse(item) : item)
      } else if (Array.isArray(histArr)) {
        history = histArr.map((item: YDocValue) =>
          typeof item === 'string' ? JSON.parse(item) : item)
      } else { history = [] }
      return { history, picked_index: v.get('picked_index') ?? 0 }
    }
    // Plain dict shape: convert Y.Map to plain object
    return v.toJSON()
  }
  // TODO: Add a YDoc room migration to convert legacy JSON-string map fields
  // to native Y.Map, then remove this fallback.
  // Fallback: legacy JSON string
  if (typeof v === 'string') { try { return JSON.parse(v) } catch { return v } }
  return v
}

export const YDOC_DESERIALIZERS: Record<string, Record<string, (v: YDocValue) => YDocValue>> = {
  audio: {
    in_file_name: _ydocPassthrough,
    out_audio: _ydocPassthrough,
  },
  brand_film: {
    in_plan: _ydocPassthrough,
    in_clips: _ydocParseArray,
    in_voiceover: _ydocParseArray,
    in_music: _ydocPassthrough,
    in_name: _ydocPassthrough,
    out_video: _ydocPassthrough,
    out_render_log: _ydocPassthrough,
    out_name: _ydocPassthrough,
  },
  captioner: {
    in_video: _ydocPassthrough,
    in_language: _ydocPassthrough,
    in_caption_style: _ydocPassthrough,
    in_name: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    out_video: _ydocPassthrough,
    out_transcript: _ydocParseArray,
    out_name: _ydocPassthrough,
  },
  character_designer: {
    in_upstream: _ydocParseJson,
    in_images: _ydocParseArray,
    in_ref_images: _ydocParseArray,
    in_name: _ydocPassthrough,
    in_role: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_description: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_feedback_history: _ydocParseArray,
    in_pronunciation_guide: _ydocPassthrough,
    in_bg_color: _ydocPassthrough,
    in_voice_descriptor: _ydocPassthrough,
    out_name: _ydocPassthrough,
    out_character_sheet: _ydocParseJson,
    out_voice_profile: _ydocParseJson,
    out_image: _ydocPassthrough,
  },
  debug_hang: {
    in_label: _ydocPassthrough,
    out_result: _ydocPassthrough,
  },
  director: {
    in_context: _ydocPassthrough,
    out_response: _ydocPassthrough,
    out_crew: _ydocParseJson,
  },
  director_stage: {
    in_name: _ydocPassthrough,
    in_scene: _ydocParseJson,
    out_captures: _ydocParseArray,
  },
  generated_image_with_history: {
  },
  hyperframe_renderer: {
    in_template_html: _ydocPassthrough,
    in_props_json: _ydocPassthrough,
    in_media: _ydocParseArray,
    in_duration_seconds: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_resolution: _ydocPassthrough,
    in_fps: _ydocPassthrough,
    in_strict_lint: _ydocPassthrough,
    in_name: _ydocPassthrough,
    out_video: _ydocPassthrough,
    out_render_log: _ydocPassthrough,
    out_actual_duration_seconds: _ydocPassthrough,
    out_frame_count: _ydocPassthrough,
  },
  image: {
    in_file_name: _ydocPassthrough,
    in_source: _ydocPassthrough,
    out_image: _ydocPassthrough,
  },
  image_generator: {
    in_images: _ydocParseArray,
    in_ref_images: _ydocParseArray,
    in_upstream: _ydocParseJson,
    in_storyboard_meta: _ydocParseJson,
    in_name: _ydocPassthrough,
    in_prompt: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_quality: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_panel_refs: _ydocParseArray,
    in_update: _ydocPassthrough,
    in_image: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_video: _ydocPassthrough,
    in_frame: _ydocPassthrough,
    in_get_frame: _ydocPassthrough,
    in_feedback_history: _ydocParseArray,
    out_generated_image: _ydocParseMap,
    out_image: _ydocPassthrough,
  },
  location_designer: {
    in_images: _ydocParseArray,
    in_ref_images: _ydocParseArray,
    in_name: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_time_of_day: _ydocPassthrough,
    in_weather: _ydocPassthrough,
    in_description: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_feedback_history: _ydocParseArray,
    in_bg_color: _ydocPassthrough,
    out_name: _ydocPassthrough,
    out_location_image: _ydocParseJson,
    out_metadata: _ydocParseJson,
    out_image: _ydocPassthrough,
  },
  node_group: {
    in_label: _ydocPassthrough,
    in_child_node_ids: _ydocParseArray,
    in_layout_mode: _ydocPassthrough,
    in_bg_color: _ydocPassthrough,
  },
  object_designer: {
    in_images: _ydocParseArray,
    in_ref_images: _ydocParseArray,
    in_name: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_description: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_feedback_history: _ydocParseArray,
    out_name: _ydocPassthrough,
    out_object_image: _ydocParseJson,
    out_metadata: _ydocParseJson,
    out_image: _ydocPassthrough,
  },
  panel_source: {
    out_image: _ydocPassthrough,
    out_action: _ydocPassthrough,
    out_character_ids: _ydocParseArray,
    out_appearances: _ydocParseArray,
    out_dialogue: _ydocParseArray,
    out_script: _ydocPassthrough,
    out_composition: _ydocParseJson,
  },
  prompt_input: {
    out_prompt: _ydocPassthrough,
  },
  remotion_composer: {
    in_clip: _ydocPassthrough,
    in_clips: _ydocParseArray,
    in_audio: _ydocPassthrough,
    in_brand_name: _ydocPassthrough,
    in_tagline: _ydocPassthrough,
    in_captions: _ydocParseJson,
    in_composition_id: _ydocPassthrough,
    in_aspect: _ydocPassthrough,
    in_clip_duration_seconds: _ydocPassthrough,
    in_name: _ydocPassthrough,
    out_video: _ydocPassthrough,
  },
  screenplay_writer: {
    in_story_context: _ydocParseJson,
    in_characters: _ydocParseArray,
    in_locations: _ydocParseArray,
    in_user_script: _ydocPassthrough,
    in_style: _ydocPassthrough,
    out_panels: _ydocParseArray,
    out_transitions: _ydocParseArray,
    out_dialogue: _ydocParseArray,
    out_music_prompts: _ydocParseArray,
  },
  script_writer: {
    in_prompt: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_active_model: _ydocPassthrough,
    in_name: _ydocPassthrough,
    in_director_instruction: _ydocPassthrough,
    in_format_only: _ydocPassthrough,
    in_gemini: _ydocPassthrough,
    in_claude: _ydocPassthrough,
    in_gpt: _ydocPassthrough,
    in_characters: _ydocParseArray,
    in_feedback: _ydocPassthrough,
    in_target_duration_s: _ydocPassthrough,
    in_ending: _ydocPassthrough,
    in_review_history: _ydocParseArray,
    in_feedback_history: _ydocParseArray,
    in_bg_color: _ydocPassthrough,
    out_script: _ydocPassthrough,
    out_script_path: _ydocPassthrough,
    out_screenplay: _ydocParseArray,
    out_dialogue: _ydocParseArray,
    out_voice_roles: _ydocParseArray,
    out_voice_profiles: _ydocParseArray,
    out_action_lines: _ydocParseArray,
    out_characters: _ydocParseArray,
    out_music_cues: _ydocParseArray,
    out_sfx: _ydocParseArray,
    out_gemini: _ydocParseJson,
    out_claude: _ydocParseJson,
    out_gpt: _ydocParseJson,
    out_locations: _ydocParseArray,
    out_active_model: _ydocPassthrough,
    out_scene_count: _ydocPassthrough,
  },
  short_video_group: {
    in_label: _ydocPassthrough,
    in_collapsed: _ydocPassthrough,
    in_storyboard_path: _ydocPassthrough,
    in_image: _ydocPassthrough,
    in_child_node_ids: _ydocParseArray,
  },
  singing_portrait: {
    in_image: _ydocPassthrough,
    in_audio: _ydocPassthrough,
    in_audio_start_s: _ydocPassthrough,
    in_lyrics: _ydocPassthrough,
    in_song_style: _ydocPassthrough,
    in_motion: _ydocPassthrough,
    in_scenes: _ydocParseArray,
    in_prompt: _ydocPassthrough,
    in_duration: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_name: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    out_video: _ydocPassthrough,
    out_song: _ydocPassthrough,
    out_name: _ydocPassthrough,
  },
  sound_expert: {
    in_name: _ydocPassthrough,
    in_upstream: _ydocParseJson,
    in_prompt: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_feedback_history: _ydocParseArray,
    in_mode: _ydocPassthrough,
    in_duration: _ydocPassthrough,
    in_voice_profile: _ydocParseJson,
    in_text: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_loop: _ydocPassthrough,
    in_lyrics_mode: _ydocPassthrough,
    in_voice_map: _ydocParseJson,
    in_scene_id: _ydocPassthrough,
    in_panel_index: _ydocPassthrough,
    in_pause_ms: _ydocPassthrough,
    in_character_name: _ydocPassthrough,
    out_audio: _ydocPassthrough,
    out_duration_seconds: _ydocPassthrough,
    in_generated_audio: _ydocParseJson,
  },
  speech_generator: {
    in_mode: _ydocPassthrough,
    in_script: _ydocPassthrough,
    in_text: _ydocPassthrough,
    in_character_name: _ydocPassthrough,
    in_voice_id: _ydocPassthrough,
    in_voice_profile: _ydocParseJson,
    in_voice_map: _ydocParseJson,
    in_scene_id: _ydocPassthrough,
    in_panel_index: _ydocPassthrough,
    in_pause_ms: _ydocPassthrough,
    in_pronunciation_guide: _ydocPassthrough,
    in_language_code: _ydocPassthrough,
    out_audio: _ydocPassthrough,
    out_duration_seconds: _ydocPassthrough,
    out_waveform: _ydocParseArray,
    out_generated_audio: _ydocParseJson,
  },
  story_direction_preview: {
  },
  storyboard_designer: {
    in_script: _ydocPassthrough,
    in_characters: _ydocParseArray,
    in_character_names: _ydocParseArray,
    in_locations: _ydocParseArray,
    in_location_names: _ydocParseArray,
    in_objects: _ydocParseArray,
    in_object_names: _ydocParseArray,
    in_image: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_panel_count: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_scene_id: _ydocPassthrough,
    in_location: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_dialogue_mode: _ydocPassthrough,
    out_storyboard_grid: _ydocParseArray,
    out_metadata: _ydocParseJson,
    out_beats: _ydocParseArray,
    out_panel_refs: _ydocParseArray,
    out_images: _ydocParseArray,
    out_grid_descriptions: _ydocParseArray,
  },
  storyboard_no_enhance_designer: {
    in_script: _ydocPassthrough,
    in_characters: _ydocParseArray,
    in_character_names: _ydocParseArray,
    in_locations: _ydocParseArray,
    in_location_names: _ydocParseArray,
    in_style: _ydocPassthrough,
    in_panel_count: _ydocPassthrough,
    in_scene_id: _ydocPassthrough,
    in_location: _ydocPassthrough,
    in_model: _ydocPassthrough,
    out_storyboard_grid: _ydocPassthrough,
  },
  text: {
    in_input: _ydocPassthrough,
    out_text: _ydocPassthrough,
  },
  video: {
    in_file_name: _ydocPassthrough,
    in_source: _ydocPassthrough,
    out_video: _ydocPassthrough,
  },
  video_editor: {
    in_videos: _ydocParseArray,
    in_audios: _ydocParseArray,
    in_audio: _ydocPassthrough,
    in_mode: _ydocPassthrough,
    in_output_name: _ydocPassthrough,
    in_start: _ydocPassthrough,
    in_end: _ydocPassthrough,
    in_volume: _ydocPassthrough,
    in_timeline_config: _ydocParseJson,
    in_export_name: _ydocPassthrough,
    in_name: _ydocPassthrough,
    out_video: _ydocPassthrough,
  },
  video_generator: {
    in_mode: _ydocPassthrough,
    in_scene_id: _ydocPassthrough,
    in_clip_number: _ydocPassthrough,
    in_images: _ydocParseArray,
    in_audio: _ydocPassthrough,
    in_motion_prompt: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_feedback_history: _ydocParseArray,
    in_scene_context: _ydocPassthrough,
    in_duration: _ydocPassthrough,
    in_dialogue_prompt: _ydocParseArray,
    in_model: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_resolution: _ydocPassthrough,
    in_generate_audio: _ydocPassthrough,
    in_tts_provider: _ydocPassthrough,
    in_voice_profiles: _ydocParseArray,
    in_voice_settings: _ydocParseJson,
    in_name: _ydocPassthrough,
    in_resolved_voice_map: _ydocParseMap,
    in_audio_remix_config: _ydocParseJson,
    in_dialogue_mode: _ydocPassthrough,
    in_style_anchor: _ydocPassthrough,
    in_storyboard_meta: _ydocParseJson,
    out_generated_video: _ydocParseMap,
    out_remixed_video: _ydocPassthrough,
    out_replacement_mix: _ydocPassthrough,
    out_tts_segments: _ydocParseArray,
    out_audio_remix_baseline: _ydocParseJson,
    out_auto_dialogue: _ydocParseArray,
    out_speech_windows: _ydocParseArray,
    out_video_prompt: _ydocPassthrough,
    out_video_duration: _ydocPassthrough,
    out_dialogue: _ydocParseArray,
    out_video: _ydocPassthrough,
  },
  webtoon_group: {
    in_scene_id: _ydocPassthrough,
    in_label: _ydocPassthrough,
    in_collapsed: _ydocPassthrough,
    in_child_node_ids: _ydocParseArray,
  },
  webtoon_panel_generator: {
    in_images: _ydocParseArray,
    in_prompt: _ydocPassthrough,
    in_beats: _ydocParseArray,
    in_dialogue: _ydocParseArray,
    in_panel_index: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_layout: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_name: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_feedback_history: _ydocParseArray,
    out_panel_image: _ydocParseMap,
    out_image: _ydocPassthrough,
  },
}

/** Frontend type to backend type mapping (from schema type → backendType) */
export const FE_TYPE_TO_BACKEND: Record<string, string> = {
  audio: 'audio',
  brandFilm: 'brand_film',
  captioner: 'captioner',
  characterDesigner: 'character_designer',
  debugHang: 'debug_hang',
  director: 'director',
  directorStage: 'director_stage',
  generatedImageWithHistory: 'generated_image_with_history',
  hyperframeRenderer: 'hyperframe_renderer',
  image: 'image',
  imageGenerator: 'image_generator',
  locationDesigner: 'location_designer',
  nodeGroup: 'node_group',
  objectDesigner: 'object_designer',
  panelSource: 'panel_source',
  promptInput: 'prompt_input',
  remotionComposer: 'remotion_composer',
  screenplayWriter: 'screenplay_writer',
  scriptWriter: 'script_writer',
  shortVideoGroup: 'short_video_group',
  singingPortrait: 'singing_portrait',
  soundExpert: 'sound_expert',
  speechGenerator: 'speech_generator',
  storyDirectionPreview: 'story_direction_preview',
  storyboardDesigner: 'storyboard_designer',
  storyboardNoEnhanceDesigner: 'storyboard_no_enhance_designer',
  text: 'text',
  video: 'video',
  videoEditor: 'video_editor',
  videoGenerator: 'video_generator',
  webtoonGroup: 'webtoon_group',
  webtoonPanelGenerator: 'webtoon_panel_generator',
}

/** Node types hidden on the ReactFlow canvas (from canvasHidden in schemas) */
export const CANVAS_HIDDEN_FE_TYPES: ReadonlySet<string> = new Set(['director', 'hyperframeRenderer', 'storyDirectionPreview'])
